var _rect, _rect2, _path, _ellipse, _path2, _rect3, _path3, _ellipse2, _path4, _rect4, _path5, _ellipse3, _path6, _path7, _rect5, _rect6, _rect7, _rect8, _rect9, _path8, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path9, _rect28, _rect29, _path10, _path11, _path12, _rect30, _rect31, _path13, _path14, _rect32, _rect33, _path15, _path16, _rect34, _rect35, _rect36, _path17, _rect37, _path18, _path19, _rect38, _rect39, _rect40, _path20, _rect41, _path21, _path22, _rect42, _rect43, _rect44, _path23, _path24, _path25, _rect45, _rect46, _rect47, _rect48, _path26, _path27, _path28, _rect49, _rect50, _rect51, _path29, _path30, _path31, _rect52, _path32, _path33, _path34, _path35, _path36, _path37, _rect53, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _ellipse4, _path66, _path67, _rect54, _path68, _ellipse5, _ellipse6, _path69, _path70, _path71, _path72, _rect55, _path73, _path74, _path75, _rect56, _path76, _path77, _path78, _rect57, _path79, _path80, _path81, _rect58, _path82, _path83, _path84, _rect59, _path85, _path86, _path87, _rect60, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _ellipse7, _path104, _path105, _path106, _ellipse8, _path107, _path108, _path109, _ellipse9, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _circle, _circle2, _circle3, _path117, _circle4, _circle5, _circle6, _path118, _circle7, _circle8, _circle9, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _ellipse10, _ellipse11, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _ellipse12, _ellipse13, _path230, _path231, _path232, _path233, _ellipse14, _path234, _path235, _path236, _ellipse15, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _rect61, _ellipse16, _rect62, _rect63, _ellipse17, _rect64, _rect65, _ellipse18, _rect66, _rect67, _ellipse19, _rect68, _path261, _ellipse20, _rect69, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _ellipse21, _path309, _path310, _ellipse22, _path311, _path312, _ellipse23, _path313, _ellipse24, _ellipse25, _path314, _path315, _path316, _path317, _ellipse26, _ellipse27, _path318, _path319, _path320, _path321, _ellipse28, _ellipse29, _path322, _path323, _path324, _path325, _path326, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _path327, _path328, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _ellipse30, _path386, _path387, _path388, _ellipse31, _path389, _path390, _path391, _ellipse32, _path392, _path393, _rect70, _rect71, _rect72, _ellipse33, _ellipse34, _g, _path394, _rect73, _rect74, _rect75, _ellipse35, _ellipse36, _g2, _path395, _path396, _path397, _ellipse37, _rect76, _path398, _path399, _path400, _ellipse38, _rect77, _path401, _path402, _path403, _ellipse39, _rect78, _path404, _rect79, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _path405, _path406, _path407, _path408, _path409, _path410, _rect80, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _rect81, _path422, _path423, _path424, _rect82, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _circle46, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroceryStoreGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4896_19525)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#E7E7E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    width: 4,
    height: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.887 54.6884C121.829 50.7471 126.441 47.6307 131.455 45.4504C132.01 41.6182 133.788 38.0404 136.558 35.27C139.945 31.8832 144.539 29.9805 149.328 29.9805C154.118 29.9805 158.712 31.8832 162.098 35.27C164.944 38.1153 166.742 41.8122 167.244 45.7615C171.988 47.9232 176.355 50.9309 180.113 54.6884C188.274 62.8498 192.898 73.8872 192.998 85.4185C192.999 85.4367 193 85.455 193 85.4733C193 85.487 193 85.5006 192.999 85.5143C193 85.6099 193 85.7055 193 85.8011H192.94C191.738 89.0943 172.525 91.7121 149 91.7121C125.475 91.7121 106.262 89.0943 105.06 85.8011H105C105 85.7055 105 85.6099 105.001 85.5143C105 85.5006 105 85.487 105 85.4733C105 85.455 105.001 85.4367 105.002 85.4185C105.102 73.8872 109.726 62.8498 117.887 54.6884Z",
    fill: "#B9BEC6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.431,
    cy: 83.902,
    rx: 41.8431,
    ry: 5.60784,
    fill: "#67717E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.803 80.8823C160.565 80.8823 162.886 83.1914 161.907 85.7737C161.858 85.9048 161.806 86.0352 161.752 86.1648C161.059 87.8396 160.042 89.3613 158.76 90.6431C157.478 91.9249 155.957 92.9417 154.282 93.6355C152.607 94.3292 150.812 94.6862 148.999 94.6862C147.186 94.6862 145.391 94.3292 143.717 93.6355C142.042 92.9417 140.52 91.9249 139.238 90.6431C137.957 89.3613 136.94 87.8396 136.246 86.1648C136.192 86.0352 136.141 85.9048 136.091 85.7737C135.112 83.1914 137.434 80.8823 140.195 80.8823L148.999 80.8823H157.803Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    width: 4,
    height: 30,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.887 54.6884C223.829 50.7471 228.441 47.6307 233.455 45.4504C234.01 41.6182 235.788 38.0404 238.558 35.27C241.945 31.8832 246.539 29.9805 251.328 29.9805C256.118 29.9805 260.712 31.8832 264.098 35.27C266.944 38.1153 268.742 41.8122 269.244 45.7615C273.988 47.9232 278.355 50.9309 282.113 54.6884C290.274 62.8498 294.898 73.8872 294.998 85.4185C294.999 85.4367 295 85.455 295 85.4733C295 85.487 295 85.5006 294.999 85.5143C295 85.6099 295 85.7055 295 85.8011H294.94C293.738 89.0943 274.525 91.7121 251 91.7121C227.475 91.7121 208.262 89.0943 207.06 85.8011H207C207 85.7055 207 85.6099 207.001 85.5143C207 85.5006 207 85.487 207 85.4733C207 85.455 207.001 85.4367 207.002 85.4185C207.102 73.8872 211.726 62.8498 219.887 54.6884Z",
    fill: "#B9BEC6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.431,
    cy: 83.902,
    rx: 41.8431,
    ry: 5.60784,
    fill: "#67717E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.803 80.8823C262.565 80.8823 264.886 83.1914 263.907 85.7737C263.858 85.9048 263.806 86.0352 263.752 86.1648C263.059 87.8396 262.042 89.3613 260.76 90.6431C259.478 91.9249 257.957 92.9417 256.282 93.6355C254.607 94.3292 252.812 94.6862 250.999 94.6862C249.186 94.6862 247.391 94.3292 245.717 93.6355C244.042 92.9417 242.52 91.9249 241.238 90.6431C239.957 89.3613 238.94 87.8396 238.246 86.1648C238.192 86.0352 238.141 85.9048 238.091 85.7737C237.112 83.1914 239.434 80.8823 242.195 80.8823L250.999 80.8823H259.803Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    width: 4,
    height: 30,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8873 54.6884C23.8286 50.7471 28.4407 47.6307 33.4552 45.4504C34.0105 41.6182 35.7878 38.0404 38.5582 35.27C41.9451 31.8832 46.5386 29.9805 51.3284 29.9805C56.1181 29.9805 60.7116 31.8832 64.0985 35.27C66.9437 38.1153 68.7416 41.8122 69.2438 45.7615C73.9881 47.9232 78.3552 50.9309 82.1127 54.6884C90.2741 62.8498 94.8982 73.8872 94.9983 85.4185C94.9994 85.4367 95 85.455 95 85.4733C95 85.487 94.9997 85.5006 94.9991 85.5143C94.9997 85.6099 95 85.7055 95 85.8011H94.9403C93.7379 89.0943 74.525 91.7121 51 91.7121C27.475 91.7121 8.26206 89.0943 7.0597 85.8011H7C7 85.7055 7.00031 85.6099 7.00093 85.5143C7.00031 85.5006 7 85.487 7 85.4733C7 85.455 7.00055 85.4367 7.00166 85.4185C7.10181 73.8872 11.7259 62.8498 19.8873 54.6884Z",
    fill: "#B9BEC6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.431,
    cy: 83.902,
    rx: 41.8431,
    ry: 5.60784,
    fill: "#67717E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8032 80.8823C62.5646 80.8823 64.886 83.1914 63.9075 85.7737C63.8578 85.9048 63.8061 86.0352 63.7524 86.1648C63.0587 87.8396 62.0419 89.3613 60.7601 90.6431C59.4783 91.9249 57.9565 92.9417 56.2818 93.6355C54.607 94.3292 52.812 94.6862 50.9992 94.6862C49.1865 94.6862 47.3915 94.3292 45.7167 93.6355C44.0419 92.9417 42.5202 91.9249 41.2384 90.6431C39.9566 89.3613 38.9398 87.8396 38.2461 86.1648C38.1924 86.0352 38.1407 85.9048 38.091 85.7737C37.1125 83.1914 39.4339 80.8823 42.1953 80.8823L50.9992 80.8823H59.8032Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 383H196C198.761 383 201 385.239 201 388V395C201 397.761 198.761 400 196 400H0V383Z",
    fill: "#67717E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    width: 400,
    height: 58,
    fill: "#B9BEC6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 400,
    width: 300,
    height: 58,
    fill: "#505862"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 58,
    width: 400,
    height: 143,
    fill: "#67717E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 516,
    width: 275,
    height: 171,
    fill: "#67717E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 414,
    width: 375,
    height: 172,
    fill: "#67717E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M901 449H1201V800H901V449Z",
    fill: "#9DA4AF"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 192,
    width: 400,
    height: 9,
    fill: "#505862"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 902,
    y: 780,
    width: 298,
    height: 20,
    fill: "#505862"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 444,
    width: 9,
    height: 356,
    fill: "#505862"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1191,
    y: 444,
    width: 9,
    height: 356,
    fill: "#505862"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 529,
    y: 16,
    width: 141,
    height: 26,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1017,
    y: 416,
    width: 68,
    height: 26,
    fill: "#D5D8DD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 16,
    width: 69,
    height: 4,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 921,
    y: 416,
    width: 68,
    height: 4,
    fill: "#D5D8DD"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 16,
    width: 65,
    height: 4,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1115,
    y: 416,
    width: 68,
    height: 4,
    fill: "#D5D8DD"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 28,
    width: 69,
    height: 3,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 921,
    y: 428,
    width: 68,
    height: 3,
    fill: "#D5D8DD"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 28,
    width: 65,
    height: 3,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1115,
    y: 428,
    width: 68,
    height: 3,
    fill: "#D5D8DD"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 38,
    width: 69,
    height: 4,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 921,
    y: 438,
    width: 68,
    height: 4,
    fill: "#D5D8DD"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 38,
    width: 65,
    height: 4,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 1115,
    y: 438,
    width: 68,
    height: 4,
    fill: "#D5D8DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M787 401H401V409V414V586V595V599H799V594V586V414V401H787ZM787 586V414H413V586H787Z",
    fill: "#F1F2F4"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 909,
    y: 578,
    width: 282,
    height: 13,
    fill: "#505862"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 909,
    y: 680,
    width: 282,
    height: 13,
    fill: "#505862"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299 501H12H0V515.214V685.786V689.066V700H299V686.879V685.786V515.214V502.093V501ZM287 685.786V515.214H12V685.786H287Z",
    fill: "#F1F2F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M912.844 742.037H949.712L944.584 777.015C944.376 778.439 943.154 779.494 941.715 779.494H920.841C919.401 779.494 918.18 778.439 917.971 777.015L912.844 742.037Z",
    fill: "#F1F2F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.393 757.771C940.715 757.639 941.931 757.475 943.006 757.282C944.538 757.009 945.753 756.683 946.582 756.326C947.411 755.968 947.837 755.584 947.837 755.197H947.994L947.04 761.703C946.863 761.717 946.686 761.731 946.508 761.744C944.032 761.927 941.464 762.065 938.845 762.155C937.545 764.618 934.646 766.333 931.278 766.333C927.908 766.333 925.007 764.616 923.709 762.151C921.134 762.06 918.61 761.924 916.174 761.744C915.996 761.731 915.818 761.717 915.641 761.704L914.688 755.197H914.844C914.844 755.584 915.271 755.968 916.1 756.326C916.929 756.683 918.144 757.009 919.676 757.282C920.718 757.469 921.892 757.629 923.166 757.759C923.966 754.559 927.294 752.16 931.278 752.16C935.267 752.16 938.599 754.566 939.393 757.771Z",
    fill: "#B9BEC6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 911,
    y: 739,
    width: 40.555,
    height: 4.04939,
    rx: 2.0247,
    fill: "#505862"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 1.84805,
    height: 29.3145,
    rx: 0.924023,
    transform: "matrix(0.985247 -0.171139 0.142519 0.989792 915.609 746.403)",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M953.844 742.037H990.712L985.584 777.015C985.376 778.439 984.154 779.494 982.715 779.494H961.841C960.401 779.494 959.18 778.439 958.971 777.015L953.844 742.037Z",
    fill: "#F1F2F4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M980.394 757.771C981.715 757.639 982.931 757.475 984.006 757.282C985.538 757.009 986.753 756.683 987.582 756.326C988.411 755.968 988.837 755.584 988.837 755.197H988.994L988.04 761.703C987.863 761.717 987.686 761.731 987.508 761.744C985.032 761.927 982.464 762.065 979.845 762.155C978.546 764.618 975.646 766.333 972.278 766.333C968.908 766.333 966.007 764.616 964.709 762.151C962.134 762.06 959.61 761.924 957.174 761.744C956.996 761.731 956.818 761.717 956.641 761.704L955.688 755.197H955.844C955.844 755.584 956.271 755.968 957.1 756.326C957.929 756.683 959.144 757.009 960.676 757.282C961.718 757.469 962.892 757.629 964.166 757.759C964.966 754.559 968.294 752.16 972.278 752.16C976.267 752.16 979.599 754.566 980.394 757.771Z",
    fill: "#B9BEC6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 952,
    y: 739,
    width: 40.555,
    height: 4.04939,
    rx: 2.0247,
    fill: "#505862"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 1.84805,
    height: 29.3145,
    rx: 0.924023,
    transform: "matrix(0.985247 -0.171139 0.142519 0.989792 956.609 746.403)",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M936.578 705.6H968.144L963.806 735.19C963.598 736.614 962.376 737.67 960.937 737.67H943.785C942.346 737.67 941.125 736.614 940.916 735.19L936.578 705.6Z",
    fill: "#F1F2F4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.309 719.072C960.44 718.958 961.482 718.818 962.402 718.653C963.713 718.419 964.754 718.14 965.464 717.834C966.173 717.528 966.539 717.199 966.539 716.867H966.673L965.856 722.438C965.705 722.45 965.553 722.462 965.4 722.473C963.28 722.63 961.082 722.748 958.839 722.825C957.727 724.934 955.245 726.402 952.361 726.402C949.476 726.402 946.992 724.932 945.88 722.821C943.676 722.744 941.514 722.627 939.429 722.473C939.276 722.462 939.124 722.45 938.973 722.438L938.156 716.867H938.29C938.29 717.199 938.656 717.528 939.366 717.834C940.075 718.14 941.116 718.419 942.427 718.653C943.319 718.813 944.324 718.95 945.415 719.061C946.101 716.322 948.95 714.268 952.361 714.268C955.776 714.268 958.629 716.327 959.309 719.072Z",
    fill: "#B9BEC6"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 935,
    y: 703,
    width: 34.7227,
    height: 3.46703,
    rx: 1.73352,
    fill: "#505862"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 1.58227,
    height: 25.0987,
    rx: 0.791136,
    transform: "matrix(0.985247 -0.171139 0.142519 0.989792 938.945 709.338)",
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1036.21,
    y: 492,
    width: 10,
    height: 8.97662,
    rx: 3,
    transform: "rotate(35.5055 1036.21 492)",
    fill: "#B9BEC6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1029 491H1027V493.698L1009 506.263V577H1047V506.263L1029 493.698V491Z",
    fill: "#B9BEC6"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 1014,
    y: 515,
    width: 3,
    height: 42,
    rx: 1.5,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1028 496L1044.45 507.25H1011.55L1028 496Z",
    fill: "#D5D8DD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1028 496L1011.5 507.25H1021L1028 496Z",
    fill: "#505862"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1035.78,
    y: 494,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "rotate(36.4192 1035.78 494)",
    fill: "#505862"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1022,
    y: 526,
    width: 25,
    height: 31,
    fill: "#505862"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1078.21,
    y: 492,
    width: 10,
    height: 8.97662,
    rx: 3,
    transform: "rotate(35.5055 1078.21 492)",
    fill: "#B9BEC6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1071 491H1069V493.698L1051 506.263V577H1089V506.263L1071 493.698V491Z",
    fill: "#B9BEC6"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 1056,
    y: 515,
    width: 3,
    height: 42,
    rx: 1.5,
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1070 496L1086.45 507.25H1053.55L1070 496Z",
    fill: "#D5D8DD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1070 496L1053.5 507.25H1063L1070 496Z",
    fill: "#505862"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1077.78,
    y: 494,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "rotate(36.4192 1077.78 494)",
    fill: "#505862"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1064,
    y: 526,
    width: 25,
    height: 31,
    fill: "#505862"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 940.213,
    y: 492,
    width: 10,
    height: 8.97662,
    rx: 3,
    transform: "rotate(35.5055 940.213 492)",
    fill: "#D5D8DD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M933 491H931V493.698L913 506.263V577H951V506.263L933 493.698V491Z",
    fill: "#F1F2F4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M932 496L948.454 507.25H915.546L932 496Z",
    fill: "#D5D8DD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M932 496L915.5 507.25H925L932 496Z",
    fill: "#818A98"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 939.781,
    y: 494,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "rotate(36.4192 939.781 494)",
    fill: "#818A98"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 926,
    y: 526,
    width: 25,
    height: 31,
    fill: "#D5D8DD"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 918,
    y: 515,
    width: 3,
    height: 42,
    rx: 1.5,
    fill: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 982.213,
    y: 492,
    width: 10,
    height: 8.97662,
    rx: 3,
    transform: "rotate(35.5055 982.213 492)",
    fill: "#D5D8DD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M975 491H973V493.698L955 506.263V577H993V506.263L975 493.698V491Z",
    fill: "#F1F2F4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M974 496L990.454 507.25H957.546L974 496Z",
    fill: "#D5D8DD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M974 496L957.5 507.25H967L974 496Z",
    fill: "#818A98"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 981.781,
    y: 494,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "rotate(36.4192 981.781 494)",
    fill: "#818A98"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 526,
    width: 25,
    height: 31,
    fill: "#D5D8DD"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 515,
    width: 3,
    height: 42,
    rx: 1.5,
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1178 505C1178 499.477 1173.52 495 1168 495H1161C1155.48 495 1151 499.477 1151 505V512.861C1151 516.343 1148.81 519.426 1147.26 522.542C1146.71 523.651 1146.35 524.879 1146.25 526.183L1142.89 567.183C1142.41 573.009 1147.01 578 1152.85 578H1177.15C1182.99 578 1187.59 573.009 1187.11 567.183L1183.75 526.183C1183.63 524.752 1183.22 523.411 1182.57 522.22C1180.71 518.805 1178 515.442 1178 511.553V505Z",
    fill: "#D5D8DD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.39 484.351C1151.18 482.567 1152.58 481 1154.37 481H1174.63C1176.42 481 1177.82 482.567 1177.61 484.351L1176.31 495.351C1176.13 496.861 1174.85 498 1173.33 498H1155.67C1154.15 498 1152.87 496.861 1152.69 495.351L1151.39 484.351Z",
    fill: "#505862"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1147.01 569.347C1148.36 572.062 1150.65 569.056 1150.87 566.033L1153.58 528.985C1153.67 527.807 1153.96 526.697 1154.4 525.695C1154.67 525.094 1154.96 524.495 1155.25 523.893C1156.33 521.674 1157.42 519.422 1157.42 516.947V509.843C1157.42 504.853 1161.03 500.807 1165.49 500.807H1171.14C1171.14 500.807 1171.14 500.807 1171.14 500.807C1169.79 499.672 1168.12 499 1166.3 499H1160.65C1156.19 499 1152.58 503.046 1152.58 508.036V515.14C1152.58 517.614 1151.48 519.866 1150.41 522.085C1150.12 522.687 1149.83 523.287 1149.56 523.888C1149.11 524.889 1148.83 525.999 1148.74 527.177L1146.03 564.226C1145.89 566.081 1146.26 567.843 1147.01 569.347Z",
    fill: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 1152.96,
    y: 483.446,
    width: 3,
    height: 13.1632,
    rx: 1.5,
    transform: "rotate(-8.63853 1152.96 483.446)",
    fill: "#F1F2F4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.45 534.953C1155.48 533.315 1156.81 532 1158.45 532H1180.73C1182.29 532 1183.59 533.205 1183.72 534.766L1185.75 560.766C1185.88 562.51 1184.51 564 1182.76 564H1158.05C1156.37 564 1155.02 562.628 1155.05 560.953L1155.45 534.953Z",
    fill: "#F1F2F4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.24 550.177C1182.38 553.387 1179.31 555.724 1175.72 556.674C1172.13 557.624 1168.31 557.109 1165.1 555.243C1161.89 553.376 1159.56 550.311 1158.61 546.722C1157.66 543.132 1158.17 539.313 1160.04 536.103L1172.14 543.14L1184.24 550.177Z",
    fill: "#67717E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.51 549.172C1181.05 551.694 1178.55 553.477 1175.57 554.129C1172.58 554.781 1169.36 554.249 1166.61 552.649C1163.86 551.049 1161.8 548.513 1160.89 545.599C1159.99 542.684 1160.3 539.63 1161.77 537.108L1172.14 543.14L1182.51 549.172Z",
    fill: "#B9BEC6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.15 505C1143.15 499.477 1138.67 495 1133.15 495H1126.15C1120.62 495 1116.15 499.477 1116.15 505V512.861C1116.15 516.343 1113.96 519.426 1112.41 522.542C1111.86 523.651 1111.5 524.879 1111.39 526.183L1108.03 567.183C1107.56 573.009 1112.16 578 1118 578H1142.29C1148.14 578 1152.74 573.009 1152.26 567.183L1148.9 526.183C1148.78 524.752 1148.37 523.411 1147.72 522.22C1145.86 518.805 1143.15 515.442 1143.15 511.553V505Z",
    fill: "#B9BEC6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.54 484.351C1116.33 482.567 1117.73 481 1119.52 481H1139.77C1141.57 481 1142.96 482.567 1142.75 484.351L1141.46 495.351C1141.28 496.861 1140 498 1138.48 498H1120.82C1119.29 498 1118.01 496.861 1117.84 495.351L1116.54 484.351Z",
    fill: "#505862"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1112.16 569.347C1113.51 572.062 1115.8 569.056 1116.02 566.033L1118.73 528.985C1118.82 527.807 1119.1 526.697 1119.55 525.695C1119.82 525.094 1120.11 524.495 1120.4 523.893C1121.48 521.674 1122.57 519.422 1122.57 516.947V509.843C1122.57 504.853 1126.18 500.807 1130.64 500.807H1136.29C1136.29 500.807 1136.29 500.807 1136.29 500.807C1134.94 499.672 1133.27 499 1131.45 499H1125.8C1121.34 499 1117.73 503.046 1117.73 508.036V515.14C1117.73 517.614 1116.63 519.866 1115.56 522.085C1115.26 522.687 1114.97 523.287 1114.71 523.888C1114.26 524.889 1113.98 525.999 1113.89 527.177L1111.18 564.226C1111.04 566.081 1111.41 567.843 1112.16 569.347Z",
    fill: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 1118.11,
    y: 483.446,
    width: 3,
    height: 13.1632,
    rx: 1.5,
    transform: "rotate(-8.63853 1118.11 483.446)",
    fill: "#F1F2F4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.6 534.953C1120.63 533.315 1121.96 532 1123.6 532H1145.87C1147.44 532 1148.74 533.205 1148.86 534.766L1150.9 560.766C1151.03 562.51 1149.65 564 1147.9 564H1123.2C1121.52 564 1120.17 562.628 1120.2 560.953L1120.6 534.953Z",
    fill: "#F1F2F4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.39 550.177C1147.52 553.387 1144.46 555.724 1140.87 556.674C1137.28 557.624 1133.46 557.109 1130.25 555.243C1127.04 553.376 1124.7 550.311 1123.75 546.722C1122.8 543.132 1123.32 539.313 1125.19 536.103L1137.29 543.14L1149.39 550.177Z",
    fill: "#505862"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.66 549.172C1146.2 551.694 1143.7 553.477 1140.71 554.129C1137.73 554.781 1134.51 554.249 1131.76 552.649C1129.01 551.049 1126.95 548.513 1126.04 545.599C1125.13 542.684 1125.45 539.63 1126.91 537.108L1137.29 543.14L1147.66 549.172Z",
    fill: "#B9BEC6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M909.729 666.55C909.364 665.272 910.323 664 911.652 664H995.348C996.677 664 997.636 665.272 997.271 666.55L994.126 677.55C993.88 678.408 993.095 679 992.203 679H914.797C913.905 679 913.12 678.408 912.874 677.55L909.729 666.55Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M929 664C929 660.817 928.21 657.765 926.803 655.515C925.397 653.264 923.489 652 921.5 652C919.511 652 917.603 653.264 916.197 655.515C914.79 657.765 914 660.817 914 664L921.5 664H929Z",
    fill: "#B9BEC6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M918.016 657.08C916.825 659.047 916.778 661.197 916.145 660.814C915.513 660.431 915.966 658.527 917.157 656.56C918.349 654.594 919.827 653.311 920.459 653.694C921.092 654.077 919.207 655.114 918.016 657.08Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M945 664C945 660.817 944.21 657.765 942.803 655.515C941.397 653.264 939.489 652 937.5 652C935.511 652 933.603 653.264 932.197 655.515C930.79 657.765 930 660.817 930 664L937.5 664H945Z",
    fill: "#B9BEC6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M934.016 657.08C932.825 659.047 932.778 661.197 932.145 660.814C931.513 660.431 931.966 658.527 933.157 656.56C934.349 654.594 935.827 653.311 936.459 653.694C937.092 654.077 935.207 655.114 934.016 657.08Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M961 664C961 660.817 960.21 657.765 958.803 655.515C957.397 653.264 955.489 652 953.5 652C951.511 652 949.603 653.264 948.197 655.515C946.79 657.765 946 660.817 946 664L953.5 664H961Z",
    fill: "#B9BEC6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M950.016 657.08C948.825 659.047 948.778 661.197 948.145 660.814C947.513 660.431 947.966 658.527 949.157 656.56C950.349 654.594 951.827 653.311 952.459 653.694C953.092 654.077 951.207 655.114 950.016 657.08Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M977 664C977 660.817 976.21 657.765 974.803 655.515C973.397 653.264 971.489 652 969.5 652C967.511 652 965.603 653.264 964.197 655.515C962.79 657.765 962 660.817 962 664L969.5 664H977Z",
    fill: "#B9BEC6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M966.016 657.08C964.825 659.047 964.778 661.197 964.145 660.814C963.513 660.431 963.966 658.527 965.157 656.56C966.349 654.594 967.827 653.311 968.459 653.694C969.092 654.077 967.207 655.114 966.016 657.08Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M993 664C993 660.817 992.21 657.765 990.803 655.515C989.397 653.264 987.489 652 985.5 652C983.511 652 981.603 653.264 980.197 655.515C978.79 657.765 978 660.817 978 664L985.5 664H993Z",
    fill: "#B9BEC6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M982.016 657.08C980.825 659.047 980.778 661.197 980.145 660.814C979.513 660.431 979.966 658.527 981.157 656.56C982.349 654.594 983.827 653.311 984.459 653.694C985.092 654.077 983.207 655.114 982.016 657.08Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M997.271 660.45C997.636 661.728 996.677 663 995.348 663L911.652 663C910.323 663 909.364 661.728 909.729 660.45L912.874 649.45C913.12 648.592 913.905 648 914.797 648L992.203 648C993.095 648 993.88 648.592 994.126 649.45L997.271 660.45Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M909.729 634.55C909.364 633.272 910.323 632 911.652 632H995.348C996.677 632 997.636 633.272 997.271 634.55L994.126 645.55C993.88 646.408 993.095 647 992.203 647H914.797C913.905 647 913.12 646.408 912.874 645.55L909.729 634.55Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M929 632C929 628.817 928.21 625.765 926.803 623.515C925.397 621.264 923.489 620 921.5 620C919.511 620 917.603 621.264 916.197 623.515C914.79 625.765 914 628.817 914 632L921.5 632H929Z",
    fill: "#B9BEC6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M918.016 625.08C916.825 627.047 916.778 629.197 916.145 628.814C915.513 628.431 915.966 626.527 917.157 624.56C918.349 622.594 919.827 621.311 920.459 621.694C921.092 622.077 919.207 623.114 918.016 625.08Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M945 632C945 628.817 944.21 625.765 942.803 623.515C941.397 621.264 939.489 620 937.5 620C935.511 620 933.603 621.264 932.197 623.515C930.79 625.765 930 628.817 930 632L937.5 632H945Z",
    fill: "#B9BEC6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M934.016 625.08C932.825 627.047 932.778 629.197 932.145 628.814C931.513 628.431 931.966 626.527 933.157 624.56C934.349 622.594 935.827 621.311 936.459 621.694C937.092 622.077 935.207 623.114 934.016 625.08Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M961 632C961 628.817 960.21 625.765 958.803 623.515C957.397 621.264 955.489 620 953.5 620C951.511 620 949.603 621.264 948.197 623.515C946.79 625.765 946 628.817 946 632L953.5 632H961Z",
    fill: "#B9BEC6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M950.016 625.08C948.825 627.047 948.778 629.197 948.145 628.814C947.513 628.431 947.966 626.527 949.157 624.56C950.349 622.594 951.827 621.311 952.459 621.694C953.092 622.077 951.207 623.114 950.016 625.08Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M977 632C977 628.817 976.21 625.765 974.803 623.515C973.397 621.264 971.489 620 969.5 620C967.511 620 965.603 621.264 964.197 623.515C962.79 625.765 962 628.817 962 632L969.5 632H977Z",
    fill: "#B9BEC6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M966.016 625.08C964.825 627.047 964.778 629.197 964.145 628.814C963.513 628.431 963.966 626.527 965.157 624.56C966.349 622.594 967.827 621.311 968.459 621.694C969.092 622.077 967.207 623.114 966.016 625.08Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M993 632C993 628.817 992.21 625.765 990.803 623.515C989.397 621.264 987.489 620 985.5 620C983.511 620 981.603 621.264 980.197 623.515C978.79 625.765 978 628.817 978 632L985.5 632H993Z",
    fill: "#B9BEC6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M982.016 625.08C980.825 627.047 980.778 629.197 980.145 628.814C979.513 628.431 979.966 626.527 981.157 624.56C982.349 622.594 983.827 621.311 984.459 621.694C985.092 622.077 983.207 623.114 982.016 625.08Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M997.271 628.45C997.636 629.728 996.677 631 995.348 631L911.652 631C910.323 631 909.364 629.728 909.729 628.45L912.874 617.45C913.12 616.592 913.905 616 914.797 616L992.203 616C993.095 616 993.88 616.592 994.126 617.45L997.271 628.45Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.02 650.283C1137.54 681.28 1147.82 677.283 1161.15 677.283C1174.48 677.283 1185.29 665.195 1185.29 650.283C1185.29 635.372 1174.48 623.283 1161.15 623.283C1147.82 623.283 1136.48 618.284 1137.02 650.283Z",
    fill: "#D5D8DD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 24.1364,
    ry: 27,
    transform: "matrix(-1 0 0 1 1147.14 650.284)",
    fill: "#F1F2F4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.36 648.784C1127.93 634.384 1139.63 627.784 1145.53 626.284C1149.82 626.284 1153.57 627.284 1145.53 629.284C1137.48 631.284 1133.19 638.784 1131.58 643.284C1129.97 647.784 1128.9 666.784 1128.36 648.784Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1155 662L1122.01 650C1112.44 651.976 1108.68 658.824 1108 662H1155Z",
    fill: "#B9BEC6"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 16,
    transform: "matrix(-1 0 0 1 1155 662)",
    fill: "#F1F2F4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.54 666.844C1148.54 666.425 1148.63 666.013 1148.81 665.65C1148.99 665.286 1149.24 664.983 1149.55 664.77C1149.86 664.558 1150.21 664.443 1150.57 664.438C1150.93 664.432 1151.28 664.536 1151.59 664.739C1151.9 664.942 1152.17 665.237 1152.35 665.595C1152.54 665.953 1152.64 666.362 1152.65 666.781C1152.66 667.199 1152.57 667.614 1152.41 667.983C1152.24 668.351 1151.99 668.662 1151.68 668.884L1150.59 666.844H1148.54Z",
    fill: "#B9BEC6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.08154,
    ry: 2.38441,
    transform: "matrix(0.954192 0.299194 0.223199 -0.974773 1144.13 673.031)",
    fill: "#B9BEC6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.18532,
    ry: 1.35779,
    transform: "matrix(0.954192 0.299194 0.223199 -0.974773 1111.59 665.696)",
    fill: "#B9BEC6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.7 668.902C1130.07 669.422 1130.58 669.774 1131.14 669.897C1131.71 670.019 1132.29 669.904 1132.79 669.571C1133.29 669.238 1133.68 668.709 1133.88 668.077C1134.08 667.445 1134.08 666.751 1133.89 666.117C1133.69 665.483 1133.31 664.95 1132.81 664.613C1132.31 664.275 1131.73 664.154 1131.16 664.271C1130.6 664.388 1130.08 664.736 1129.71 665.252C1129.34 665.769 1129.14 666.422 1129.14 667.095L1131.59 667.086L1129.7 668.902Z",
    fill: "#B9BEC6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.74 673.507C1122.61 674.077 1122.31 674.57 1121.89 674.894C1121.47 675.219 1120.96 675.351 1120.46 675.266C1119.96 675.18 1119.51 674.884 1119.18 674.433C1118.86 673.981 1118.69 673.407 1118.7 672.817C1118.72 672.228 1118.91 671.665 1119.26 671.236C1119.6 670.806 1120.07 670.54 1120.57 670.488C1121.08 670.435 1121.58 670.6 1121.98 670.951C1122.39 671.303 1122.67 671.815 1122.77 672.392L1120.76 672.884L1122.74 673.507Z",
    fill: "#B9BEC6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.26 616.106C1072.26 613.286 1069.98 611 1067.16 611C1064.34 611 1062.05 613.286 1062.05 616.106V635.395C1062.05 639.852 1058.87 643.57 1055.44 646.42C1051.5 649.699 1049 654.601 1049 660.078C1049 665.068 1051.08 669.58 1054.43 672.822C1055.26 673.629 1055.81 674.707 1055.81 675.866C1055.81 677.957 1057.5 679.652 1059.6 679.652H1074.72C1076.81 679.652 1078.5 677.957 1078.5 675.866C1078.5 674.707 1079.05 673.629 1079.88 672.822C1083.23 669.58 1085.31 665.068 1085.31 660.078C1085.31 654.601 1082.81 649.699 1078.87 646.42C1075.44 643.57 1072.26 639.852 1072.26 635.395V616.106Z",
    fill: "#9DA4AF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.77 663.621C1074.32 666.169 1078.66 666.139 1079.68 662.681C1079.79 662.31 1079.88 661.934 1079.95 661.553C1080.46 659.022 1080.2 656.398 1079.21 654.013C1078.22 651.629 1076.55 649.591 1074.41 648.157C1072.26 646.723 1069.74 645.958 1067.16 645.958C1064.57 645.958 1062.05 646.723 1059.91 648.157C1057.76 649.591 1056.09 651.629 1055.1 654.013C1054.11 656.398 1053.85 659.022 1054.36 661.553C1054.43 661.934 1054.52 662.31 1054.63 662.681C1055.65 666.139 1059.99 666.169 1062.54 663.621C1065.09 661.073 1069.22 661.073 1071.77 663.621Z",
    fill: "#F1F2F4"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 1062.05,
    y: 610.78,
    width: 10.2128,
    height: 4.53901,
    fill: "#F1F2F4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1062 605C1062 602.239 1064.24 600 1067 600H1067.21C1069.97 600 1072.21 602.239 1072.21 605V610.78H1062V605Z",
    fill: "#505862"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.26 616.454C1043.26 613.634 1040.98 611.347 1038.16 611.347C1035.34 611.347 1033.05 613.634 1033.05 616.454V635.743C1033.05 640.2 1029.87 643.917 1026.44 646.768C1022.5 650.046 1020 654.948 1020 660.425C1020 665.415 1022.08 669.928 1025.43 673.17C1026.26 673.976 1026.81 675.054 1026.81 676.213C1026.81 678.305 1028.5 680 1030.6 680H1045.72C1047.81 680 1049.5 678.305 1049.5 676.213C1049.5 675.054 1050.05 673.976 1050.88 673.17C1054.23 669.928 1056.31 665.415 1056.31 660.425C1056.31 654.948 1053.81 650.046 1049.87 646.768C1046.44 643.917 1043.26 640.2 1043.26 635.743V616.454Z",
    fill: "#B9BEC6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.77 663.621C1045.32 666.169 1049.66 666.139 1050.68 662.681C1050.79 662.31 1050.88 661.934 1050.95 661.553C1051.46 659.022 1051.2 656.398 1050.21 654.013C1049.22 651.629 1047.55 649.591 1045.41 648.157C1043.26 646.723 1040.74 645.958 1038.16 645.958C1035.57 645.958 1033.05 646.723 1030.91 648.157C1028.76 649.591 1027.09 651.629 1026.1 654.013C1025.11 656.398 1024.85 659.022 1025.36 661.553C1025.43 661.934 1025.52 662.31 1025.63 662.681C1026.65 666.139 1030.99 666.169 1033.54 663.621C1036.09 661.073 1040.22 661.073 1042.77 663.621Z",
    fill: "#F1F2F4"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1033.05,
    y: 610.78,
    width: 10.2128,
    height: 4.53901,
    fill: "#F1F2F4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.05 605C1033.05 602.239 1035.29 600 1038.05 600H1038.26C1041.02 600 1043.26 602.239 1043.26 605V610.78H1033.05V605Z",
    fill: "#505862"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.41 742.89H1084.22L1082.54 774.442C1082.4 776.998 1080.29 779.001 1077.73 779.001H1034.32C1031.79 779.001 1029.68 777.035 1029.52 774.506L1027.41 742.89Z",
    fill: "#D5D8DD"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1029.81 734.223C1028.49 734.223 1027.41 735.3 1027.41 736.63V738.556C1026.08 738.556 1025 739.634 1025 740.963V742.889H1087.11V740.963C1087.11 739.634 1086.03 738.556 1084.7 738.556L1084.22 738.556V736.63C1084.22 735.3 1083.14 734.223 1081.81 734.223H1029.81Z",
    fill: "#505862"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.52,
    y: 746.742,
    width: 37.0741,
    height: 24.0741,
    rx: 1.44444,
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.2 761.186L1074.83 746.742V769.371C1074.83 770.169 1074.19 770.816 1073.39 770.816H1037.76L1052.2 761.186Z",
    fill: "#9DA4AF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.41 742.89H1175.22L1173.54 774.442C1173.4 776.998 1171.29 779.001 1168.73 779.001H1125.32C1122.79 779.001 1120.68 777.035 1120.52 774.506L1118.41 742.89Z",
    fill: "#D5D8DD"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1120.81 734.223C1119.49 734.223 1118.41 735.3 1118.41 736.63V738.556C1117.08 738.556 1116 739.634 1116 740.963V742.889H1178.11V740.963C1178.11 739.634 1177.03 738.556 1175.7 738.556L1175.22 738.556V736.63C1175.22 735.3 1174.14 734.223 1172.81 734.223H1120.81Z",
    fill: "#505862"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1128.52,
    y: 746.742,
    width: 37.0741,
    height: 24.0741,
    rx: 1.44444,
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.2 761.186L1165.83 746.742V769.371C1165.83 770.169 1165.19 770.816 1164.39 770.816H1128.76L1143.2 761.186Z",
    fill: "#9DA4AF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.79 707.45H1077.07L1075.82 730.931C1075.72 732.833 1074.15 734.323 1072.24 734.323H1039.93C1038.05 734.323 1036.49 732.861 1036.36 730.978L1034.79 707.45Z",
    fill: "#D5D8DD"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1036.58 701C1035.59 701 1034.79 701.802 1034.79 702.792V704.225H1034.79C1033.8 704.225 1033 705.027 1033 706.016V707.449H1079.22V706.016C1079.22 705.027 1078.42 704.225 1077.43 704.225H1077.07V702.792C1077.07 701.802 1076.27 701 1075.28 701H1036.58Z",
    fill: "#505862"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1042.32,
    y: 710.316,
    width: 27.59,
    height: 17.9156,
    rx: 1.07494,
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.25 721.065L1070.09 710.316V727.157C1070.09 727.75 1069.6 728.232 1069.01 728.232H1042.5L1053.25 721.065Z",
    fill: "#9DA4AF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 707.45H1167.07L1165.82 730.931C1165.72 732.833 1164.15 734.323 1162.24 734.323H1129.93C1128.05 734.323 1126.49 732.861 1126.36 730.978L1124.79 707.45Z",
    fill: "#D5D8DD"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1126.58 701C1125.59 701 1124.79 701.802 1124.79 702.792V704.225H1124.79C1123.8 704.225 1123 705.027 1123 706.016V707.449H1169.22V706.016C1169.22 705.027 1168.42 704.225 1167.43 704.225H1167.07V702.792C1167.07 701.802 1166.27 701 1165.28 701H1126.58Z",
    fill: "#505862"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 1132.32,
    y: 710.316,
    width: 27.59,
    height: 17.9156,
    rx: 1.07494,
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.25 721.065L1160.09 710.316V727.157C1160.09 727.75 1159.6 728.232 1159.01 728.232H1132.5L1143.25 721.065Z",
    fill: "#9DA4AF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M225.397 546.339C251.217 533.73 253.379 530.285 255.433 524.123C256.634 520.521 264.666 517.758 265.627 525.924C266.828 536.131 247.801 556.064 239.208 564.953C221.795 582.967 193.659 561.838 225.397 546.339Z",
    fill: "#818A98"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M254.232 524.69C254.232 522.272 258.694 520.157 260.925 519.402C266.948 519.402 268.956 526.956 266.279 527.711C264.531 528.204 263.853 526.718 263.663 525.471C263.607 526.488 263.011 527.711 260.925 527.711C258.248 527.711 257.579 525.697 257.579 524.69C256.463 525.697 254.232 527.107 254.232 524.69Z",
    fill: "#3A3F46"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M263.239 521.203V517H260.236L260.837 520.603L263.239 521.203Z",
    fill: "#3A3F46"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M231.416 565.036C239.102 562.635 249.029 550.426 253.032 544.621C254.317 542.82 251.831 541.619 250.63 544.621C249.429 547.623 238.021 557.831 231.416 562.034C224.811 566.237 221.809 568.039 231.416 565.036Z",
    fill: "#F1F2F4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M246.397 574.339C272.217 561.73 274.379 558.285 276.433 552.123C277.634 548.521 285.666 545.758 286.627 553.924C287.828 564.131 268.801 584.064 260.208 592.953C242.795 610.967 214.659 589.838 246.397 574.339Z",
    fill: "#9DA4AF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M275.232 552.69C275.232 550.272 279.694 548.157 281.925 547.402C287.948 547.402 289.956 554.956 287.279 555.711C285.531 556.204 284.853 554.718 284.663 553.471C284.607 554.488 284.011 555.711 281.925 555.711C279.248 555.711 278.579 553.697 278.579 552.69C277.463 553.697 275.232 555.107 275.232 552.69Z",
    fill: "#3A3F46"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M284.239 549.203V545H281.236L281.837 548.603L284.239 549.203Z",
    fill: "#3A3F46"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M252.416 593.036C260.102 590.635 270.029 578.426 274.032 572.621C275.317 570.82 272.831 569.619 271.63 572.621C270.429 575.623 259.021 585.831 252.416 590.034C245.811 594.237 242.809 596.039 252.416 593.036Z",
    fill: "#D5D8DD"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M220.62 565.672C254.014 549.364 256.812 544.908 259.468 536.939C261.021 532.28 271.409 528.706 272.652 539.268C274.205 552.47 249.597 578.249 238.483 589.747C215.961 613.045 179.572 585.718 220.62 565.672Z",
    fill: "#B9BEC6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M257.914 537.671C257.914 534.545 263.685 531.809 266.57 530.832C274.36 530.832 276.957 540.602 273.494 541.579C271.234 542.217 270.357 540.295 270.111 538.682C270.039 539.997 269.268 541.579 266.57 541.579C263.108 541.579 262.242 538.974 262.242 537.671C260.799 538.974 257.914 540.798 257.914 537.671Z",
    fill: "#505862"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M269.565 533.163V527.727H265.682L266.458 532.386L269.565 533.163Z",
    fill: "#505862"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M228.404 589.854C238.344 586.748 251.184 570.957 256.361 563.45C258.024 561.12 254.808 559.567 253.255 563.45C251.701 567.333 236.946 580.535 228.404 585.971C219.861 591.407 215.978 593.737 228.404 589.854Z",
    fill: "#F1F2F4"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5 577.159C150.5 589.222 140.091 599 127.25 599C114.409 599 104 589.222 104 577.159C104 565.097 114.409 556.728 127.25 556.728C140.091 556.728 150.5 565.097 150.5 577.159Z",
    fill: "#B9BEC6"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M110.606 579.273C107.788 571.946 111.78 564.947 114.129 562.364C117.651 562.364 117.652 567.296 114.129 570.819C110.606 574.341 114.129 588.432 110.606 579.273Z",
    fill: "#F1F2F4"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M115.955 559.382C118.774 557.127 124.645 558.442 127.228 559.382C133.569 557.267 142.023 559.382 137.796 559.382C133.569 559.382 128.637 561.496 132.864 561.496C135.96 561.496 137.167 565.653 137.591 567.324C137.724 567.513 137.796 567.687 137.796 567.837C137.796 568.214 137.746 567.935 137.591 567.324C136.47 565.741 131.005 563.13 127.228 565.018C123.001 567.132 127.228 574.882 123.705 569.246C120.183 563.609 123.705 563.609 123.705 561.496C123.705 559.382 112.433 562.2 115.955 559.382Z",
    fill: "#818A98"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.249,
    cy: 561.659,
    rx: 3.52273,
    ry: 2.11364,
    fill: "#67717E"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M197 577.159C197 589.222 186.591 599 173.75 599C160.909 599 150.5 589.222 150.5 577.159C150.5 565.097 160.909 556.728 173.75 556.728C186.591 556.728 197 565.097 197 577.159Z",
    fill: "#B9BEC6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M157.106 579.273C154.288 571.946 158.28 564.947 160.629 562.364C164.151 562.364 164.152 567.296 160.629 570.819C157.106 574.341 160.629 588.432 157.106 579.273Z",
    fill: "#F1F2F4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M162.455 559.382C165.274 557.127 171.145 558.442 173.728 559.382C180.069 557.267 188.523 559.382 184.296 559.382C180.069 559.382 175.137 561.496 179.364 561.496C182.46 561.496 183.667 565.653 184.091 567.324C184.224 567.513 184.296 567.687 184.296 567.837C184.296 568.214 184.246 567.935 184.091 567.324C182.97 565.741 177.505 563.13 173.728 565.018C169.501 567.132 173.728 574.882 170.205 569.246C166.683 563.609 170.205 563.609 170.205 561.496C170.205 559.382 158.933 562.2 162.455 559.382Z",
    fill: "#818A98"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.749,
    cy: 561.659,
    rx: 3.52273,
    ry: 2.11364,
    fill: "#67717E"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M173.045 537.704C173.045 549.767 162.636 559.545 149.795 559.545C136.954 559.545 126.545 549.767 126.545 537.704C126.545 525.642 136.954 517.272 149.795 517.272C162.636 517.272 173.045 525.642 173.045 537.704Z",
    fill: "#B9BEC6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M133.151 539.818C130.333 532.491 134.325 525.492 136.674 522.909C140.196 522.909 140.197 527.841 136.674 531.363C133.151 534.886 136.674 548.977 133.151 539.818Z",
    fill: "#F1F2F4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 519.926C141.318 517.672 147.19 518.987 149.773 519.926C156.114 517.812 164.568 519.926 160.341 519.926C156.114 519.926 151.182 522.041 155.409 522.041C158.505 522.041 159.712 526.198 160.136 527.869C160.269 528.058 160.341 528.232 160.341 528.382C160.341 528.759 160.291 528.48 160.136 527.869C159.015 526.286 153.55 523.675 149.773 525.563C145.546 527.677 149.773 535.427 146.25 529.791C142.728 524.154 146.25 524.154 146.25 522.041C146.25 519.927 134.978 522.745 138.5 519.926Z",
    fill: "#818A98"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.794,
    cy: 522.204,
    rx: 3.52273,
    ry: 2.11364,
    fill: "#67717E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2373 558.176C62.6099 580.365 63.8494 590.402 57.8198 593.764C51.7903 597.126 40.7749 592.54 28.4024 570.352C16.0299 548.163 10.8879 527.45 16.9175 524.088C22.947 520.726 37.8648 535.988 50.2373 558.176Z",
    fill: "#9DA4AF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6824 587.599C32.6487 577.731 18.1487 551.264 16.0539 533.513C14.5983 521.177 20.421 529.717 20.421 536.834C20.421 543.951 42.7415 577.636 44.6824 580.957C46.6233 584.278 59.7244 599.935 44.6824 587.599Z",
    fill: "#505862"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2373 554.176C99.6099 576.365 100.849 586.402 94.8198 589.764C88.7903 593.126 77.7749 588.54 65.4024 566.352C53.0299 544.163 47.8879 523.45 53.9175 520.088C59.947 516.726 74.8648 531.988 87.2373 554.176Z",
    fill: "#B9BEC6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6824 583.599C69.6487 573.731 55.1487 547.264 53.0539 529.513C51.5983 517.177 57.421 525.717 57.421 532.834C57.421 539.951 79.7415 573.636 81.6824 576.957C83.6233 580.278 96.7244 595.935 81.6824 583.599Z",
    fill: "#9DA4AF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2373 561.176C80.6099 583.365 81.8494 593.402 75.8198 596.764C69.7903 600.126 58.7749 595.54 46.4024 573.352C34.0299 551.163 28.8879 530.45 34.9175 527.088C40.947 523.726 55.8648 538.988 68.2373 561.176Z",
    fill: "#D5D8DD"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6824 590.599C50.6487 580.731 36.1487 554.264 34.0539 536.513C32.5983 524.177 38.421 532.717 38.421 539.834C38.421 546.951 60.7415 580.636 62.6824 583.957C64.6233 587.278 77.7244 602.935 62.6824 590.599Z",
    fill: "#B9BEC6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.5 640C251.523 640 248.269 643.096 248.016 647.009C241.337 647.264 236 652.759 236 659.5C236 666.068 241.066 671.454 247.504 671.961C246.181 673.966 244.379 675.97 242 677.5C235 682 242.5 687 246.5 686.5C249.701 686.1 252.582 682.177 256.168 677.295C256.659 676.626 257.164 675.939 257.684 675.24C259.973 678.139 263.519 680 267.5 680C274.404 680 280 674.404 280 667.5C280 665.509 279.534 663.626 278.706 661.956C280.751 659.73 282 656.761 282 653.5C282 646.596 276.404 641 269.5 641C266.639 641 264.002 641.962 261.895 643.579C260.575 641.432 258.205 640 255.5 640Z",
    fill: "#D5D8DD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 252.5,
    cy: 666.5,
    r: 7.5,
    fill: "#B9BEC6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 654,
    r: 9,
    fill: "#9DA4AF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 662,
    r: 11,
    fill: "#B9BEC6"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.5 606C222.523 606 219.269 609.096 219.016 613.009C212.337 613.264 207 618.759 207 625.5C207 632.068 212.066 637.454 218.504 637.961C217.181 639.966 215.379 641.97 213 643.5C206 648 213.5 653 217.5 652.5C220.701 652.1 223.582 648.177 227.168 643.295C227.659 642.626 228.164 641.939 228.684 641.24C230.973 644.139 234.519 646 238.5 646C245.404 646 251 640.404 251 633.5C251 631.509 250.534 629.626 249.706 627.956C251.751 625.73 253 622.761 253 619.5C253 612.596 247.404 607 240.5 607C237.639 607 235.002 607.962 232.895 609.579C231.575 607.432 229.205 606 226.5 606Z",
    fill: "#D5D8DD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.5,
    cy: 632.5,
    r: 7.5,
    fill: "#B9BEC6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 620,
    r: 9,
    fill: "#9DA4AF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 628,
    r: 11,
    fill: "#B9BEC6"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.756 606.709C276.727 606.709 274.857 607.391 273.363 608.538C272.428 607.015 270.747 606 268.828 606C266.008 606 263.7 608.195 263.521 610.971C258.784 611.151 255 615.048 255 619.828C255 624.486 258.593 628.305 263.158 628.665C262.22 630.087 260.942 631.508 259.255 632.593C254.291 635.784 259.609 639.33 262.446 638.975C264.716 638.692 266.759 635.91 269.302 632.447C269.65 631.973 270.008 631.486 270.377 630.991C272.001 633.046 274.515 634.366 277.338 634.366C282.234 634.366 286.203 630.397 286.203 625.502C286.203 624.09 285.872 622.755 285.285 621.57C286.735 619.992 287.621 617.886 287.621 615.574C287.621 610.678 283.652 606.709 278.756 606.709Z",
    fill: "#D5D8DD"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.701,
    cy: 624.792,
    r: 5.31861,
    fill: "#B9BEC6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.474,
    cy: 615.928,
    r: 6.38234,
    fill: "#9DA4AF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.402,
    cy: 621.601,
    r: 7.80063,
    fill: "#B9BEC6"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4976 650.279C34.3577 664.274 54.3341 686.661 57.9299 684.127C61.5258 681.594 48.3294 654.43 38.4693 640.435C28.6092 626.441 25.8194 630.914 22.2235 633.448C18.6277 635.981 14.6375 636.284 24.4976 650.279Z",
    fill: "#D5D8DD"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6061 648.598C26.5119 648.551 27.2084 648.441 27.94 647.926",
    stroke: "#67717E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4531 645.106C39.0199 646.361 38.3937 648.08 37.3215 648.978C36.9419 649.295 36.5027 649.56 36.0975 649.846",
    stroke: "#67717E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1578 657.589C33.3066 657.587 34.7284 657.805 35.7378 657.119C36.0742 656.89 36.4034 656.649 36.736 656.415C37.288 656.026 37.8399 655.637 38.3918 655.249",
    stroke: "#67717E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5273 655.455C46.3809 657.784 45.6454 659.656 43.6406 660.861C43.0219 661.232 42.5306 661.727 41.9482 662.137",
    stroke: "#67717E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5688 667.536C42.2066 667.034 43.8871 666.578 45.463 665.9C45.6348 665.826 45.7791 665.737 45.9582 665.683",
    stroke: "#67717E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1291 625.572C27.2455 626.752 25.8822 630.039 25.1191 636.855C25.0371 637.587 24.1125 637.932 23.5546 637.45C22.6903 636.702 21.5657 635.817 20.3807 635.082C17.8452 633.51 12.3979 632.748 15.3196 631.255C18.2412 629.763 23.7715 636.496 21.9381 633.57C20.1047 630.643 17.5211 620.712 20.4077 621.607C23.2943 622.502 22.2941 632.552 24.6086 625.933C26.2804 621.153 27.7008 622.774 28.3585 624.563C28.4837 624.903 28.3465 625.282 28.1291 625.572Z",
    fill: "#B9BEC6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9813 626.508C39.3473 639.801 58.3227 661.066 61.7384 658.66C65.1541 656.253 52.6189 630.45 43.2529 617.157C33.8869 603.864 31.2368 608.113 27.8212 610.52C24.4055 612.926 20.6153 613.214 29.9813 626.508Z",
    fill: "#D5D8DD"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0341 624.91C31.8945 624.866 32.5561 624.761 33.2511 624.272",
    stroke: "#67717E",
    strokeWidth: 0.408946,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1855 621.594C43.774 622.786 43.1792 624.419 42.1607 625.271C41.8002 625.573 41.3829 625.825 40.9981 626.096",
    stroke: "#67717E",
    strokeWidth: 0.408946,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2577 633.45C38.3489 633.448 39.6995 633.655 40.6583 633.003C40.9778 632.786 41.2906 632.558 41.6065 632.335C42.1308 631.966 42.6551 631.596 43.1794 631.227",
    stroke: "#67717E",
    strokeWidth: 0.408946,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9062 631.424C50.7671 633.636 50.0685 635.414 48.1642 636.558C47.5765 636.911 47.1097 637.381 46.5566 637.771",
    stroke: "#67717E",
    strokeWidth: 0.408946,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M45.248 642.899C46.8038 642.423 48.4001 641.989 49.8971 641.345C50.0602 641.275 50.1973 641.19 50.3674 641.139",
    stroke: "#67717E",
    strokeWidth: 0.408946,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4296 603.038C32.5903 604.159 31.2953 607.281 30.5705 613.755C30.4925 614.451 29.6143 614.778 29.0844 614.32C28.2633 613.61 27.1951 612.769 26.0695 612.071C23.661 610.578 18.4867 609.854 21.2619 608.436C24.0372 607.019 29.2903 613.415 27.5488 610.635C25.8073 607.855 23.3531 598.421 26.0951 599.272C28.8371 600.122 27.887 609.668 30.0855 603.381C31.6736 598.84 33.0228 600.38 33.6476 602.079C33.7665 602.403 33.6362 602.762 33.4296 603.038Z",
    fill: "#B9BEC6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4976 641.279C67.3577 655.274 87.3341 677.661 90.9299 675.127C94.5258 672.594 81.3294 645.43 71.4693 631.435C61.6092 617.441 58.8194 621.914 55.2235 624.448C51.6277 626.981 47.6375 627.284 57.4976 641.279Z",
    fill: "#D5D8DD"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6061 639.598C59.5119 639.551 60.2084 639.441 60.94 638.926",
    stroke: "#67717E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4531 636.106C72.0199 637.361 71.3937 639.08 70.3215 639.978C69.9419 640.295 69.5027 640.56 69.0975 640.846",
    stroke: "#67717E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1578 648.589C66.3066 648.587 67.7284 648.805 68.7378 648.119C69.0742 647.89 69.4034 647.649 69.736 647.415C70.288 647.026 70.8399 646.637 71.3918 646.249",
    stroke: "#67717E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5273 646.455C79.3809 648.784 78.6454 650.656 76.6406 651.861C76.0219 652.232 75.5306 652.727 74.9482 653.137",
    stroke: "#67717E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5688 658.536C75.2066 658.034 76.8871 657.578 78.463 656.9C78.6348 656.826 78.7791 656.737 78.9582 656.683",
    stroke: "#67717E",
    strokeWidth: 0.430518,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1291 616.572C60.2455 617.752 58.8822 621.039 58.1191 627.855C58.0371 628.587 57.1125 628.932 56.5546 628.45C55.6903 627.702 54.5657 626.817 53.3807 626.082C50.8452 624.51 45.3979 623.748 48.3196 622.255C51.2412 620.763 56.7715 627.496 54.9381 624.57C53.1047 621.643 50.5211 611.712 53.4077 612.607C56.2943 613.502 55.2941 623.552 57.6086 616.933C59.2804 612.153 60.7008 613.774 61.3585 615.563C61.4837 615.903 61.3465 616.282 61.1291 616.572Z",
    fill: "#B9BEC6"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8015 461.693C58.8015 474.118 46.7576 480.279 31.9007 480.279C17.0439 480.279 5 474.118 5 461.693C5 449.267 27.4988 431.368 31.9007 431.368C34.8354 431.368 58.8015 449.267 58.8015 461.693Z",
    fill: "#B9BEC6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4121 433.324C39.4008 437.563 54.7913 449.758 52.4436 464.627",
    stroke: "#818A98",
    strokeWidth: 0.978209,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4121 433.324C23.6976 437.563 8.83522 449.758 11.1024 464.627",
    stroke: "#818A98",
    strokeWidth: 0.978209,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4121 433.324C39.4008 437.563 48.5308 457.78 43.6397 472.453",
    stroke: "#818A98",
    strokeWidth: 0.978209,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4121 433.324C23.9433 437.563 15.4074 457.78 19.9802 472.453",
    stroke: "#818A98",
    strokeWidth: 0.978209,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4121 434.303C28.5395 438.754 21.63 460.226 29.9448 476.366",
    stroke: "#818A98",
    strokeWidth: 0.978209,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6623 482.724C24.6232 482.724 30.6424 478.125 33.2219 476.658C33.5567 476.468 33.9662 476.528 34.2573 476.781L39.1339 481.007C39.8182 481.6 39.4001 482.724 38.4945 482.724H25.6623Z",
    fill: "#B9BEC6"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5312 429.743C79.1983 440.702 68.9073 446.781 55.8048 447.578C42.7024 448.376 31.75 443.59 31.083 432.631C30.4159 421.673 49.2971 404.68 53.1792 404.444C55.7673 404.286 77.8642 418.785 78.5312 429.743Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8535 406.195C60.1264 409.505 74.3542 419.434 73.0819 432.673",
    stroke: "#9DA4AF",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8535 406.195C46.2775 410.348 33.8248 421.901 36.6225 434.892",
    stroke: "#9DA4AF",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8535 406.195C60.1264 409.505 69.2635 426.844 65.7377 440.047",
    stroke: "#9DA4AF",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8535 406.195C46.4942 410.335 40.0516 428.622 44.8721 441.317",
    stroke: "#9DA4AF",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9043 407.058C50.6098 411.137 45.6689 430.444 53.8683 444.232",
    stroke: "#9DA4AF",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4329 450.07C49.5165 450.125 54.578 445.746 56.7742 444.314C57.0592 444.128 57.4236 444.159 57.6939 444.366L62.2215 447.832C62.8568 448.318 62.5484 449.332 61.7498 449.381L50.4329 450.07Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9196 477.478C82.6868 486.515 70.8366 484.955 60.0304 477.502C49.2242 470.05 43.5541 459.528 49.787 450.49C56.0199 441.452 81.3626 439.719 84.5644 441.927C86.6989 443.399 95.1525 468.44 88.9196 477.478Z",
    fill: "#F1F2F4"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2266 443.105C86.9109 450.196 91.9881 466.786 82.8221 476.423",
    stroke: "#818A98",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2266 443.105C75.4891 442.319 58.5618 443.734 52.7525 455.686",
    stroke: "#818A98",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2266 443.105C86.9109 450.196 83.4109 469.48 72.4932 477.699",
    stroke: "#818A98",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2266 443.105C75.6678 442.442 59.3186 452.865 55.2844 465.831",
    stroke: "#818A98",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7363 443.817C78.4143 445.614 62.6183 457.765 60.5699 473.676",
    stroke: "#818A98",
    strokeWidth: 0.864293,
    strokeLinecap: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2645 476.152C53.5088 475.63 60.1937 475.305 62.8058 475.532C63.1449 475.561 63.4124 475.81 63.4976 476.14L64.9247 481.66C65.1249 482.435 64.2568 483.043 63.5981 482.588L54.2645 476.152Z",
    fill: "#F1F2F4"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M164.357 458.214C164.357 481 145.232 481 129.393 481C113.554 481 107 471.449 107 458.214C107 444.979 121.018 437 136.857 437C152.696 437 164.357 444.979 164.357 458.214Z",
    fill: "#B9BEC6"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 447.93C123.5 449.964 121.928 449.964 120.626 449.964C119.324 449.964 121.929 449.111 121.929 447.93C121.929 446.748 119.938 446.036 121.24 446.036C122.541 446.036 123.5 446.748 123.5 447.93Z",
    fill: "#818A98"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M142.357 472.287C142.357 474.321 141.398 472.287 140.097 472.287C138.795 472.287 137.643 473.469 137.643 472.287C137.643 471.105 138.795 470.393 140.097 470.393C141.398 470.393 142.357 471.105 142.357 472.287Z",
    fill: "#818A98"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M151.787 450.282C151.787 452.317 150.215 452.317 148.913 452.317C147.611 452.317 147.072 451.464 147.072 450.282C147.072 449.101 148.913 450.745 150.215 450.745C151.517 450.745 151.787 449.101 151.787 450.282Z",
    fill: "#818A98"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M190.35 445.964C179.48 461.648 166.315 452.525 155.413 444.969C144.51 437.414 144.555 427.713 150.868 418.603C157.182 409.492 170.638 410.687 181.54 418.243C192.443 425.798 196.663 436.854 190.35 445.964Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M167.132 419.394C166.162 420.795 165.08 420.045 164.183 419.424C163.287 418.803 165.487 419.458 166.051 418.645C166.614 417.831 165.584 416.391 166.48 417.012C167.376 417.633 167.696 418.581 167.132 419.394Z",
    fill: "#818A98"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M168.494 445.156C167.523 446.557 167.834 444.699 166.938 444.078C166.042 443.457 164.685 443.721 165.249 442.907C165.812 442.094 166.945 442.153 167.842 442.774C168.738 443.395 169.058 444.343 168.494 445.156Z",
    fill: "#818A98"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M185.481 434.507C184.51 435.908 183.428 435.158 182.532 434.537C181.636 433.916 181.672 433.072 182.236 432.258C182.799 431.445 183.282 433.455 184.178 434.076C185.074 434.697 186.044 433.694 185.481 434.507Z",
    fill: "#818A98"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M195.589 464.054C195.589 477 184.722 477 175.723 477C166.724 477 163 471.574 163 464.054C163 456.534 170.965 452 179.964 452C188.964 452 195.589 456.534 195.589 464.054Z",
    fill: "#F1F2F4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M172.375 458.21C172.375 459.366 171.482 459.366 170.742 459.366C170.003 459.366 171.482 458.882 171.482 458.21C171.482 457.539 170.351 457.134 171.091 457.134C171.83 457.134 172.375 457.539 172.375 458.21Z",
    fill: "#818A98"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M183.089 472.049C183.089 473.205 182.544 472.049 181.804 472.049C181.065 472.049 180.41 472.721 180.41 472.049C180.41 471.378 181.065 470.973 181.804 470.973C182.544 470.973 183.089 471.378 183.089 472.049Z",
    fill: "#818A98"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M188.446 459.547C188.446 460.703 187.553 460.703 186.813 460.703C186.074 460.703 185.768 460.218 185.768 459.547C185.768 458.876 186.814 459.81 187.553 459.81C188.293 459.81 188.446 458.876 188.446 459.547Z",
    fill: "#818A98"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90456 478.711C1.44402 476.821 2.87474 475 4.8192 475H95.1808C97.1253 475 98.556 476.821 98.0954 478.711L93.7074 496.711C93.3798 498.054 92.1759 499 90.7927 499H9.20726C7.82409 499 6.62021 498.054 6.29262 496.711L1.90456 478.711Z",
    fill: "#67717E"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06367 362.298C1.10754 360.307 2.55897 358 4.76813 358H188.232C190.441 358 191.892 360.307 190.936 362.298L182.295 380.298C181.795 381.338 180.744 382 179.59 382H13.4099C12.2562 382 11.2048 381.338 10.7055 380.298L2.06367 362.298Z",
    fill: "#505862"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M103.905 478.711C103.444 476.821 104.875 475 106.819 475H197.181C199.125 475 200.556 476.821 200.095 478.711L195.707 496.711C195.38 498.054 194.176 499 192.793 499H111.207C109.824 499 108.62 498.054 108.293 496.711L103.905 478.711Z",
    fill: "#67717E"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.835 358.012H136C139.706 352.833 143.817 347.522 148.277 342.205C173.828 311.736 201.129 292.56 209.256 299.375C216.591 305.527 205.797 330.751 184.835 358.012Z",
    fill: "#B9BEC6"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M184.122 322.512C182.639 320.04 183.111 318.546 175.871 317.062C175.711 317.029 175.539 317.034 175.386 317.091C173.78 317.684 172.166 319.462 177.122 322.512C183.622 326.512 185.622 325.012 184.122 322.512Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M173.122 330.512C171.639 328.04 172.111 326.546 164.871 325.062C164.711 325.029 164.539 325.034 164.386 325.091C162.78 325.684 161.166 327.462 166.122 330.512C172.622 334.512 174.622 333.012 173.122 330.512Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M165.122 340.512C163.639 338.04 164.111 336.546 156.871 335.062C156.711 335.029 156.539 335.034 156.386 335.091C154.78 335.684 153.166 337.462 158.122 340.512C164.622 344.512 166.622 343.012 165.122 340.512Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.835 358.012H96C99.7058 352.833 103.817 347.522 108.277 342.205C133.828 311.736 161.129 292.56 169.256 299.375C176.591 305.527 165.797 330.751 144.835 358.012Z",
    fill: "#F1F2F4"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M144.122 322.512C142.639 320.04 143.111 318.546 135.871 317.062C135.711 317.029 135.539 317.034 135.386 317.091C133.78 317.684 132.166 319.462 137.122 322.512C143.622 326.512 145.622 325.012 144.122 322.512Z",
    fill: "#D5D8DD"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M133.122 330.512C131.639 328.04 132.111 326.546 124.871 325.062C124.711 325.029 124.539 325.034 124.386 325.091C122.78 325.684 121.166 327.462 126.122 330.512C132.622 334.512 134.622 333.012 133.122 330.512Z",
    fill: "#D5D8DD"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M125.122 340.512C123.639 338.04 124.111 336.546 116.871 335.062C116.711 335.029 116.539 335.034 116.386 335.091C114.78 335.684 113.166 337.462 118.122 340.512C124.622 344.512 126.622 343.012 125.122 340.512Z",
    fill: "#D5D8DD"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0106 358.075C68.9757 354.125 69.5 350.144 69.5 346.34C69.5 326.602 54.6812 309 38.1216 309C21.562 309 5 332.469 5 352.208C5 354.18 5.17232 356.142 5.49903 358.075H68.0106Z",
    fill: "#B9BEC6"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1367 333.012C59.5687 333.911 60.0369 334.832 60.3583 335.816",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4949 320.552C44.6902 320.552 43.7717 320.358 42.9951 320.708C42.5932 320.889 42.2587 321.175 41.8301 321.175",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2615 329.274C31.3369 329.889 30.4377 329.879 29.8184 331.143",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3516 336.439C38.3496 336.069 39.4078 336.058 40.4055 336.439",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8242 343.604C53.3675 344.158 54.453 345.312 54.453 346.407",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9873 351.705C61.8741 352.821 61.5801 354.001 61.5801 355.131",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5838 330.832C15.7721 332.018 14.5087 333.192 14.1406 334.882",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5663 347.966C15.0966 348.182 14.752 349.12 14.752 349.835",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2422 347.966H33.2782",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5781 322.111C28.2161 321.483 28.8362 320.865 29.6141 320.865",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2055 352.741C47.9762 353.654 47.6952 354.093 47.1875 354.61",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9141 355.753C24.6611 356.624 25.6669 356.376 26.5608 356.376",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9141 339.554C24.6717 339.554 25.4041 339.242 26.1536 339.242",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5859 329.274C51.1261 329.6 51.6691 329.905 52.2147 330.208",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0106 358.075C81.9757 355.172 82.5 352.245 82.5 349.449C82.5 334.939 67.6812 322 51.1216 322C34.562 322 18 339.252 18 353.762C18 355.212 18.1723 356.654 18.499 358.075H81.0106Z",
    fill: "#F1F2F4"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1367 339.652C72.5687 340.312 73.0369 340.989 73.3583 341.713",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4949 330.492C57.6902 330.492 56.7717 330.35 55.9951 330.607C55.5932 330.74 55.2587 330.95 54.8301 330.95",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2615 336.903C44.3369 337.355 43.4377 337.348 42.8184 338.277",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3516 342.171C51.3496 341.899 52.4078 341.89 53.4055 342.171",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8242 347.438C66.3675 347.845 67.453 348.693 67.453 349.499",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9873 353.392C74.8741 354.212 74.5801 355.08 74.5801 355.911",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5838 338.049C28.7721 338.921 27.5087 339.784 27.1406 341.026",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5663 350.644C28.0966 350.802 27.752 351.492 27.752 352.018",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2422 350.644H46.2782",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5781 331.638C41.2161 331.177 41.8362 330.722 42.6141 330.722",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2055 354.154C60.9762 354.825 60.6952 355.147 60.1875 355.528",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9141 356.368C37.6611 357.009 38.6669 356.826 39.5608 356.826",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9141 344.461C37.6717 344.461 38.4041 344.232 39.1536 344.232",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5859 336.903C64.1261 337.143 64.6691 337.367 65.2147 337.59",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M72.041 346.922C78.8313 361.183 92.5963 360.64 101.861 357.527C103.655 356.924 103.4 354.257 101.79 353.26C95.3283 349.253 92.9189 340.887 87.4063 334.958C80.5971 327.634 87.637 311.121 84.9506 309.112C82.2641 307.104 61.7209 325.249 72.041 346.922Z",
    fill: "#9DA4AF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5633 358.311C89.7233 359.655 93.1547 350.029 94.2254 345.048C89.4911 354.025 80.3966 355.491 77.881 355.038C75.3655 354.584 78.1132 356.632 84.5633 358.311Z",
    fill: "#818A98"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0249 338.1C71.5316 341.269 80.5169 334.644 84.8212 330.935C75.7783 334.997 70.2829 330.903 69.6895 331.313C69.0961 331.724 68.1415 334.139 70.0249 338.1Z",
    fill: "#818A98"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7413 355.886C110.648 361.549 119.381 354.362 124.008 347.437C125.059 345.863 123.174 343.909 121.285 344.035C115.076 344.449 109.139 340.467 102.512 339.538C93.9806 338.341 89.7142 323.476 86.8269 323.593C83.9396 323.71 80.0646 347.004 98.7413 355.886Z",
    fill: "#B9BEC6"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M113.301 356.696C117.481 354.791 114.544 346.49 112.553 342.578C114.266 351.153 108.983 357.075 107.055 358.139C105.126 359.203 108.076 359.078 113.301 356.696Z",
    fill: "#9DA4AF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5985 351.084C95.3278 352.384 97.7352 343.072 98.5977 338.254C94.7591 345.883 88.8601 346.132 88.6865 346.728C88.5128 347.325 89.1869 349.459 92.5985 351.084Z",
    fill: "#9DA4AF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M410.851 133.598C426.328 151.122 423.866 143.518 467.131 140.542C471 140.255 474.869 133.598 463.262 130.623C451.654 127.647 446.73 114.091 430.197 110.454C413.665 106.817 395.375 116.075 410.851 133.598Z",
    fill: "#B9BEC6"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M410.851 131.358C426.328 148.464 423.866 141.041 467.131 138.136C471 137.856 474.869 131.358 463.262 128.453C451.654 125.548 446.73 112.315 430.197 108.764C413.665 105.214 395.375 114.251 410.851 131.358Z",
    fill: "#D5D8DD"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.65224,
    ry: 3.55244,
    transform: "matrix(-0.985598 -0.169105 -0.199929 0.97981 423.011 115.241)",
    fill: "#B9BEC6"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.99262,
    ry: 2.58359,
    transform: "matrix(-0.985598 -0.169105 -0.199929 0.97981 421.834 114.712)",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M409.77 123.038C411.445 123.431 414.339 124.122 415.223 125.74C415.528 126.298 415.63 127.134 415.677 127.762C415.786 129.193 418.836 128.381 419.312 129.722",
    stroke: "#B9BEC6",
    strokeLinecap: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M449.53 126.38C451.912 127.082 454.3 127.78 456.627 128.64C457.398 128.924 458.648 129.28 459.079 130.077C459.569 130.98 458.895 131.828 460.251 132.183C461.728 132.571 463.336 132.431 464.639 133.063",
    stroke: "#B9BEC6",
    strokeLinecap: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M443.965 134.778C443.555 134.646 440.271 133.657 440.178 133.954C440.06 134.332 439.845 134.734 439.582 135.055C438.698 136.136 436.292 135.224 435.218 134.929",
    stroke: "#B9BEC6",
    strokeLinecap: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M720.261 113.083C751.104 104.124 777.017 128.8 786.604 142.927C786.859 143.303 787.225 143.58 787.662 143.702C796.525 146.184 802.59 140.695 797.493 145.546C790.718 151.993 787.675 166.275 787.952 163.167C788.096 161.544 787.775 158.839 787.285 156.18C786.911 154.151 781.384 152.368 779.33 152.567C774.037 153.08 764.612 151.582 748.731 145.343C721.218 134.533 717.402 120.711 719.029 114.292C719.181 113.696 719.67 113.255 720.261 113.083Z",
    fill: "#D5D8DD"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M724.289 117.958C724.606 124.707 734.468 140.53 771.378 149.832C758.571 144.639 731.224 130.996 724.289 117.958Z",
    fill: "#9DA4AF"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M781.877 143.562C781.61 136.778 777.941 129.43 761.952 124.286C772.631 132.225 775.519 133.797 781.877 143.562Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M489.675 162.515C467.116 186.828 470.705 176.277 407.64 172.148C402 171.75 396.36 162.515 413.28 158.386C430.2 154.258 437.378 135.45 461.476 130.404C485.574 125.358 512.235 138.203 489.675 162.515Z",
    fill: "#D5D8DD"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M489.675 159.407C467.116 183.14 470.705 172.841 407.64 168.811C402 168.421 396.36 159.407 413.28 155.376C430.2 151.346 437.378 132.986 461.476 128.06C485.574 123.134 512.235 135.673 489.675 159.407Z",
    fill: "#9DA4AF"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.68355,
    ry: 4.93885,
    transform: "matrix(0.986926 -0.161173 0.209618 0.977783 471.954 137.046)",
    fill: "#D5D8DD"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.81199,
    ry: 3.59189,
    transform: "matrix(0.986926 -0.161173 0.209618 0.977783 473.667 136.313)",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M491.251 147.864C488.81 148.409 484.591 149.367 483.303 151.612C482.858 152.387 482.71 153.546 482.64 154.418C482.482 156.403 478.036 155.276 477.342 157.136",
    stroke: "white",
    strokeLinecap: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M433.296 152.5C429.825 153.474 426.344 154.443 422.951 155.636C421.827 156.031 420.006 156.525 419.378 157.629C418.664 158.883 419.645 160.058 417.669 160.552C415.516 161.09 413.172 160.895 411.273 161.773",
    stroke: "white",
    strokeLinecap: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M441.408 164.151C442.006 163.969 446.793 162.597 446.928 163.009C447.1 163.533 447.413 164.09 447.797 164.536C449.086 166.036 452.593 164.771 454.158 164.361",
    stroke: "white",
    strokeLinecap: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.193 114.915C626.098 113.391 625.941 111.393 624.676 110.024C623.135 108.354 620.531 108.25 618.862 109.792C618.016 110.573 617.572 111.626 617.54 112.693C616.474 112.64 615.389 112.999 614.543 113.78C612.873 115.321 612.77 117.924 614.311 119.594C615.853 121.264 618.456 121.368 620.126 119.826L620.126 119.826L626.107 126.304L631.29 121.519L625.193 114.915Z",
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 641.348,
    cy: 134.427,
    rx: 20.28,
    ry: 13.5548,
    transform: "rotate(44.6898 641.348 134.427)",
    fill: "#9DA4AF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M612.011 157.852C616.197 154.364 617.086 151.163 617.01 149.956C614.669 146.566 609.498 135.268 635.23 132.869C669.912 129.636 669.324 140.511 677.26 144.332C685.195 148.153 694.894 155.795 694.6 166.082C694.307 176.369 688.428 178.72 650.513 183.422C612.599 188.125 606.72 162.261 612.011 157.852Z",
    fill: "#D5D8DD"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M663.837 159.904C666.658 156.142 657.567 149.519 652.668 146.678C655.313 143.445 666.482 146.678 674.124 149.911C681.765 153.144 676.475 163.725 678.238 163.431C680.002 163.137 686.174 164.901 685.586 167.546C684.998 170.191 667.951 175.775 659.722 176.657C651.492 177.539 660.31 164.607 663.837 159.904Z",
    fill: "#9DA4AF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.021 123.861C602.955 123.808 601.869 124.166 601.023 124.947C599.354 126.489 599.25 129.092 600.791 130.762C602.333 132.432 604.936 132.536 606.606 130.994L606.606 130.994L612.588 137.473L617.77 132.687L611.673 126.084C612.579 124.559 612.421 122.562 611.157 121.193C609.615 119.523 607.012 119.419 605.342 120.961C604.496 121.742 604.052 122.795 604.021 123.861Z",
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 627.828,
    cy: 145.595,
    rx: 20.28,
    ry: 13.5548,
    transform: "rotate(44.6898 627.828 145.595)",
    fill: "#9DA4AF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M704.908 156.416C732.262 137.74 766.453 152.264 780.803 162.303C781.161 162.554 781.582 162.681 782.019 162.654C791.671 162.054 795.775 154.852 792.423 161.104C787.976 169.397 789.937 183.784 789.129 180.782C788.694 179.163 787.37 176.631 785.907 174.236C784.839 172.487 779.086 172.727 777.227 173.593C772.272 175.899 762.417 177.713 744.223 177.145C713.362 176.183 704.769 164.547 704.119 157.988C704.057 157.361 704.388 156.771 704.908 156.416Z",
    fill: "#F1F2F4"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M710.582 159.638C713.241 165.853 728.473 177.387 768.137 173.811C753.692 173.212 721.958 169.539 710.582 159.638Z",
    fill: "#9DA4AF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M776.32 164.445C773.699 158.181 767.524 152.522 749.955 153.027C763.254 156.906 766.65 157.417 776.32 164.445Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 184.231C401.011 182.246 402.463 180 404.64 180H493.36C495.537 180 496.989 182.246 496.096 184.231L492.945 191.231C492.461 192.308 491.39 193 490.21 193H407.79C406.61 193 405.539 192.308 405.055 191.231L401.904 184.231Z",
    fill: "#EEF2F6"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M502.904 575.231C502.011 573.246 503.463 571 505.64 571H594.36C596.537 571 597.989 573.246 597.096 575.231L593.945 582.231C593.461 583.308 592.39 584 591.21 584H508.79C507.61 584 506.539 583.308 506.055 582.231L502.904 575.231Z",
    fill: "#F1F2F4"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M700.643 575.113C699.856 573.143 701.307 571 703.429 571H781.571C783.693 571 785.144 573.143 784.357 575.113L781.56 582.113C781.105 583.253 780.001 584 778.774 584H706.226C704.999 584 703.895 583.253 703.44 582.113L700.643 575.113Z",
    fill: "#F1F2F4"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M504.904 184.231C504.011 182.246 505.463 180 507.64 180H596.36C598.537 180 599.989 182.246 599.096 184.231L595.945 191.231C595.461 192.308 594.39 193 593.21 193H510.79C509.61 193 508.539 192.308 508.055 191.231L504.904 184.231Z",
    fill: "#EEF2F6"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M504.904 151.231C504.011 149.246 505.463 147 507.64 147H596.36C598.537 147 599.989 149.246 599.096 151.231L595.945 158.231C595.461 159.308 594.39 160 593.21 160H510.79C509.61 160 508.539 159.308 508.055 158.231L504.904 151.231Z",
    fill: "#EEF2F6"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M602.904 184.231C602.011 182.246 603.463 180 605.64 180H694.36C696.537 180 697.989 182.246 697.096 184.231L693.945 191.231C693.461 192.308 692.39 193 691.21 193H608.79C607.61 193 606.539 192.308 606.055 191.231L602.904 184.231Z",
    fill: "#EEF2F6"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M702.904 184.231C702.011 182.246 703.463 180 705.64 180H794.36C796.537 180 797.989 182.246 797.096 184.231L793.945 191.231C793.461 192.308 792.39 193 791.21 193H708.79C707.61 193 706.539 192.308 706.055 191.231L702.904 184.231Z",
    fill: "#EEF2F6"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M509.347 180H596C596 169.973 592.514 171.226 587.036 166.839C581.558 162.453 524.785 163.706 515.821 166.839C508.65 169.346 508.517 176.658 509.347 180Z",
    fill: "#9DA4AF"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M583.342 168.39C583.304 169.109 582.158 170.386 581.652 169.373C581.648 169.366 580.928 170.865 580.928 169.999",
    stroke: "white",
    strokeLinecap: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M522.988 168.39C522.988 170.103 524.948 170.173 526.207 170.16C526.888 170.153 526.69 169.856 526.69 170.41C526.69 171.486 529.281 171.287 529.909 171.287",
    stroke: "white",
    strokeLinecap: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M555.016 170.643C555.751 170.681 558.163 170.788 558.163 171.894C558.163 172.649 557.645 172.354 558.386 172.261C559.161 172.164 561.155 173.677 560.488 174.344",
    stroke: "white",
    strokeLinecap: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M590.906 176.275C590.826 176.442 589.458 178.491 589.305 177.956C589.241 177.731 588.51 178.367 588.179 178.52C587.581 178.795 587.043 178.935 587.043 178.046",
    stroke: "white",
    strokeLinecap: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M510.273 177.724C511.196 176.955 512.876 176.208 513.796 177.473C513.912 177.633 513.914 178.063 514.047 177.813C514.326 177.288 514.652 176.919 515.263 176.794C516.28 176.585 516.554 177.655 517.435 177.33C517.896 177.16 518.57 177.096 518.803 177.563",
    stroke: "white",
    strokeLinecap: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M546.968 167.906C545.67 167.964 543.976 168.664 544.805 170.32C545.045 170.8 544.622 170.329 544.161 170.32C543.607 170.31 543.257 170.343 542.945 170.839C542.756 171.138 542.623 171.648 542.623 172.001C542.623 172.282 541.997 171.93 541.648 171.93C540.22 171.93 540.749 173.401 541.336 174.183",
    stroke: "white",
    strokeLinecap: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M509.347 147H596C596 136.973 592.514 138.226 587.036 133.839C581.558 129.453 524.785 130.706 515.821 133.839C508.65 136.346 508.517 143.658 509.347 147Z",
    fill: "#9DA4AF"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M583.342 135.39C583.304 136.109 582.158 137.386 581.652 136.373C581.648 136.366 580.928 137.865 580.928 136.999",
    stroke: "white",
    strokeLinecap: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M522.988 135.39C522.988 137.103 524.948 137.173 526.207 137.16C526.888 137.153 526.69 136.856 526.69 137.41C526.69 138.486 529.281 138.287 529.909 138.287",
    stroke: "white",
    strokeLinecap: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M555.016 137.643C555.751 137.681 558.163 137.788 558.163 138.894C558.163 139.649 557.645 139.354 558.386 139.261C559.161 139.164 561.155 140.677 560.488 141.344",
    stroke: "white",
    strokeLinecap: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M590.906 143.275C590.826 143.442 589.458 145.491 589.305 144.956C589.241 144.731 588.51 145.367 588.179 145.52C587.581 145.795 587.043 145.935 587.043 145.046",
    stroke: "white",
    strokeLinecap: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M510.273 144.724C511.196 143.955 512.876 143.208 513.796 144.473C513.912 144.633 513.914 145.063 514.047 144.813C514.326 144.288 514.652 143.919 515.263 143.794C516.28 143.585 516.554 144.655 517.435 144.33C517.896 144.16 518.57 144.096 518.803 144.563",
    stroke: "white",
    strokeLinecap: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M546.968 134.906C545.67 134.964 543.976 135.664 544.805 137.32C545.045 137.8 544.622 137.329 544.161 137.32C543.607 137.31 543.257 137.343 542.945 137.839C542.756 138.138 542.623 138.648 542.623 139.001C542.623 139.282 541.997 138.93 541.648 138.93C540.22 138.93 540.749 140.401 541.336 141.183",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 1014,
    y: 35.6667,
    width: 40.1538,
    height: 48.3333,
    fill: "#9DA4AF"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1034,
    cy: 36,
    rx: 20,
    ry: 7,
    fill: "#F1F2F4"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 1024.41,
    y: 52.7693,
    width: 29.7436,
    height: 21.5641,
    fill: "#F1F2F4"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 1057,
    y: 35.6667,
    width: 40.1538,
    height: 48.3333,
    fill: "#9DA4AF"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1077,
    cy: 36,
    rx: 20,
    ry: 7,
    fill: "#F1F2F4"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 1067.41,
    y: 52.7693,
    width: 29.7436,
    height: 21.5641,
    fill: "#F1F2F4"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 1106,
    y: 58,
    width: 40,
    height: 26,
    fill: "#9DA4AF"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1126,
    cy: 57.5,
    rx: 20,
    ry: 6.5,
    fill: "#F1F2F4"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 1116,
    y: 71,
    width: 30,
    height: 9,
    fill: "#F1F2F4"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 1149,
    y: 58,
    width: 40,
    height: 26,
    fill: "#9DA4AF"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1169,
    cy: 57.5,
    rx: 20,
    ry: 6.5,
    fill: "#F1F2F4"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 1159,
    y: 71,
    width: 30,
    height: 9,
    fill: "#F1F2F4"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M1126 16H1166V42C1166 42 1159.5 47.5 1146 47.5C1132.5 47.5 1126 42 1126 42V16Z",
    fill: "#9DA4AF"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1146,
    cy: 15.5,
    rx: 20,
    ry: 6.5,
    fill: "#F1F2F4"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 1136,
    y: 29,
    width: 30,
    height: 9,
    fill: "#F1F2F4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M459.031 461.181C451.255 479.126 437.651 483.128 425.323 477.786C412.995 472.444 406.611 459.782 414.387 441.837C422.163 423.891 438.461 413.673 450.788 419.015C463.116 424.357 466.807 443.235 459.031 461.181Z",
    fill: "#D5D8DD"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M426.244 430.856C425.546 433.661 428.784 434.762 430.731 433.504",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M432.949 440.82C432.252 443.625 435.49 444.726 437.436 443.468",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M446.551 437.315C445.853 440.121 449.091 441.222 451.037 439.963",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M454.518 446.809C453.82 449.615 457.058 450.716 459.004 449.457",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M421.221 442.45C420.523 445.256 423.761 446.357 425.707 445.099",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M427.926 452.413C427.228 455.218 430.466 456.319 432.412 455.061",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M441.527 448.909C440.83 451.715 444.068 452.816 446.014 451.558",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M449.494 458.403C448.796 461.208 452.034 462.309 453.981 461.051",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M416.08 454.318C415.382 457.123 418.62 458.224 420.567 456.966",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M422.785 464.28C422.088 467.086 425.325 468.187 427.272 466.929",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M436.385 460.777C435.687 463.582 438.925 464.683 440.871 463.425",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M444.352 470.271C443.654 473.076 446.892 474.177 448.838 472.919",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M431.125 472.917C430.427 475.722 433.665 476.824 435.612 475.565",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M442.142 399.158C438.09 395.893 439.428 410.678 440.603 418.478C449.4 426.212 456.201 426.871 458.501 426.234C464.235 422.055 475.291 413.068 473.65 410.547C471.599 407.396 466.473 413.093 464.009 410.894C461.399 408.564 466.809 402.68 464.847 401.075C462.794 399.395 460.765 401.444 458.628 404.038C456.751 406.619 452.183 405.771 453.515 401.823C454.846 397.874 453.167 394.956 450.096 396.57C446.164 398.637 447.207 403.238 442.142 399.158Z",
    fill: "#9DA4AF"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M490.46 478.181C482.684 496.126 469.081 500.128 456.753 494.786C444.425 489.444 438.041 476.782 445.817 458.837C453.593 440.891 469.89 430.673 482.218 436.015C494.546 441.357 498.236 460.235 490.46 478.181Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M457.674 447.856C456.976 450.661 460.214 451.762 462.16 450.504",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M464.379 457.82C463.681 460.625 466.919 461.726 468.865 460.468",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M477.98 454.315C477.283 457.12 480.521 458.221 482.467 456.963",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M485.947 463.809C485.25 466.615 488.488 467.716 490.434 466.457",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M452.65 459.45C451.953 462.256 455.191 463.357 457.137 462.099",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M459.355 469.413C458.658 472.218 461.896 473.319 463.842 472.061",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M472.957 465.908C472.259 468.714 475.497 469.815 477.444 468.557",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M480.924 475.402C480.226 478.208 483.464 479.309 485.41 478.051",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M447.51 471.318C446.812 474.123 450.05 475.224 451.996 473.966",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M454.213 481.28C453.515 484.086 456.753 485.187 458.699 483.929",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M467.814 477.776C467.117 480.581 470.355 481.682 472.301 480.424",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M475.781 487.271C475.084 490.076 478.322 491.177 480.268 489.919",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M462.555 489.917C461.857 492.722 465.095 493.824 467.041 492.565",
    stroke: "#505862",
    strokeWidth: 1.77255,
    strokeLinecap: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M473.572 416.158C469.52 412.893 470.858 427.678 472.033 435.478C480.829 443.212 487.63 443.871 489.931 443.234C495.664 439.055 506.72 430.068 505.08 427.547C503.029 424.396 497.903 430.093 495.439 427.894C492.829 425.564 498.239 419.68 496.277 418.075C494.224 416.395 492.194 418.444 490.058 421.038C488.181 423.619 483.613 422.771 484.944 418.823C486.276 414.874 484.597 411.956 481.526 413.57C477.593 415.637 478.637 420.238 473.572 416.158Z",
    fill: "#9DA4AF"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M657.403 578.585C683.745 567.505 684.452 542.325 681.512 531.12C680.85 527.67 680.929 522.288 681.05 520.028C683.49 519.493 688.002 518.836 686.539 520.483C684.711 522.542 686.427 525.172 687.8 528.602C689.174 532.031 704.5 540.487 694.561 563.704C686.61 582.278 667.85 584.793 659.464 583.729C653.975 583.274 655.803 580.11 657.403 578.585Z",
    fill: "#F1F2F4"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M690.662 534.09C695.584 544.722 704.421 570.105 669.756 582.926C679.245 578.462 699.729 560.707 690.662 534.09Z",
    fill: "#B9BEC6"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M625.737 556.775C652.875 565.731 669.952 547.213 675.098 536.834C676.866 533.799 680.461 529.793 682.038 528.169C684.228 529.369 688.062 531.839 685.877 532.119C683.145 532.47 682.711 535.58 681.493 539.068C680.275 542.556 686.273 559 663.526 569.972C645.328 578.749 629.533 568.319 623.91 562.007C620.071 558.058 623.528 556.873 625.737 556.775Z",
    fill: "#F1F2F4"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M680.045 545.084C676.769 556.333 666.754 581.275 632.197 568.163C642.283 571.033 669.392 571.107 680.045 545.084Z",
    fill: "#B9BEC6"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M663.938 536.341C637.814 543.794 621.963 524.465 617.303 513.868C615.69 510.755 612.356 506.579 610.89 504.88C608.77 505.956 605.05 508.206 607.129 508.602C609.728 509.097 610.067 512.213 611.144 515.747C612.222 519.281 606.096 535.313 627.544 547.442C644.702 557.144 660.034 547.618 665.555 541.642C669.316 537.92 666.044 536.557 663.938 536.341Z",
    fill: "#F1F2F4"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M612.382 521.806C615.236 533.168 624.188 558.507 657.496 547.318C647.798 549.632 621.918 548.255 612.382 521.806Z",
    fill: "#B9BEC6"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M497.101 567.192C490.486 579.206 472.335 592.083 450.263 579.932C428.191 567.781 421.223 549.216 431.277 530.954C438.797 517.294 460.959 508.262 483.03 520.413C505.102 532.564 507.154 548.93 497.101 567.192Z",
    fill: "#D5D8DD"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M444.391 576.132C412.908 540.145 449.655 521.243 472.325 516.488C479.007 520.167 469.646 516.026 452.042 532.187C437.959 545.116 441.851 567.806 444.391 576.132Z",
    fill: "#9DA4AF"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M489.609 526.006C511.394 557.484 477.797 576.608 458.342 582.8C453.232 579.845 459.606 582.019 476.245 565.477C489.556 552.243 490.7 533.649 489.609 526.006Z",
    fill: "#9DA4AF"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M450.68 578.425C442.876 566.296 464.64 522.976 481.605 521.626C482.42 521.561 482.785 522.506 482.245 523.12C469 538.167 457.105 564.995 452.189 578.176C451.935 578.857 451.073 579.037 450.68 578.425Z",
    fill: "#9DA4AF"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M476 551C476 555.465 475.121 559.886 473.412 564.011C471.703 568.136 469.199 571.884 466.042 575.042C462.884 578.199 459.136 580.703 455.011 582.412C450.886 584.121 446.465 585 442 585C437.535 585 433.114 584.121 428.989 582.412C424.864 580.703 421.116 578.199 417.958 575.042C414.801 571.884 412.297 568.136 410.588 564.011C408.879 559.886 408 555.465 408 551L442 551H476Z",
    fill: "#B9BEC6"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M469 551C469 554.546 468.302 558.057 466.945 561.332C465.588 564.608 463.599 567.585 461.092 570.092C458.585 572.599 455.608 574.588 452.332 575.945C449.057 577.302 445.546 578 442 578C438.454 578 434.943 577.302 431.668 575.945C428.392 574.588 425.415 572.599 422.908 570.092C420.401 567.585 418.412 564.608 417.055 561.332C415.698 558.057 415 554.546 415 551L442 551H469Z",
    fill: "#F1F2F4"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M425.471 557.758C425.5 557.497 425.702 557.375 425.93 557.299C425.983 557.281 426.484 557.179 426.315 557.348C426.134 557.529 425.779 557.753 425.544 557.831",
    stroke: "#505862",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M440.07 567.491C440.345 567.246 440.665 567.194 440.955 567.049",
    stroke: "#505862",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M454.154 557.757C454.639 557.647 455.098 557.424 455.555 557.241",
    stroke: "#505862",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M440.734 554.956C441.012 554.892 441.293 554.713 441.545 554.587",
    stroke: "#505862",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M572 439.104C572 453.464 560.359 467.604 546 467.604C531.641 467.604 520 453.464 520 439.104C520 424.745 531.641 420.604 546 420.604C560.359 420.604 572 424.745 572 439.104Z",
    fill: "#9DA4AF"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.5,
    cy: 427.104,
    rx: 8.5,
    ry: 3,
    fill: "#505862"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M545.688 426.665C545.688 423.179 545.146 418.88 543.227 416",
    stroke: "#3A3F46",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M600 470.104C600 484.464 588.359 498.604 574 498.604C559.641 498.604 548 484.464 548 470.104C548 455.745 559.641 451.604 574 451.604C588.359 451.604 600 455.745 600 470.104Z",
    fill: "#B9BEC6"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 574.5,
    cy: 458.104,
    rx: 8.5,
    ry: 3,
    fill: "#818A98"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M573.688 457.665C573.688 454.179 573.146 449.88 571.227 447",
    stroke: "#3A3F46",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M556 469.104C556 483.464 544.359 497.604 530 497.604C515.641 497.604 504 483.464 504 469.104C504 454.745 515.641 450.604 530 450.604C544.359 450.604 556 454.745 556 469.104Z",
    fill: "white"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 530.5,
    cy: 457.104,
    rx: 8.5,
    ry: 3,
    fill: "#B9BEC6"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M529.688 456.665C529.688 453.179 529.146 448.88 527.227 446",
    stroke: "#505862",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 723.188,
    cy: 452,
    rx: 20.1875,
    ry: 20,
    fill: "#D5D8DD"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 726.354,
    cy: 437.417,
    rx: 3.5625,
    ry: 2.08333,
    fill: "#9DA4AF"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M713.006 444.675C713.182 444.839 713.287 444.859 713.495 444.932",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M712.271 458.07C712.489 458.274 712.765 458.416 713.006 458.585",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M726.955 462.707C727.23 462.678 727.436 462.556 727.689 462.449",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M736.254 444.417C735.918 445.105 735.546 445.766 735.275 446.478",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 756.54,
    cy: 477.556,
    rx: 20.1875,
    ry: 20.322,
    transform: "rotate(-40.2888 756.54 477.556)",
    fill: "#D5D8DD"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 749.373,
    cy: 464.205,
    rx: 3.5625,
    ry: 2.11688,
    transform: "rotate(-40.2888 749.373 464.205)",
    fill: "#9DA4AF"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M743.961 478.462C744.203 478.476 744.297 478.424 744.504 478.346",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M752.203 489.319C752.503 489.336 752.807 489.269 753.102 489.244",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M766.449 483.419C766.639 483.218 766.716 482.991 766.839 482.744",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M761.524 463.228C761.72 463.979 761.87 464.733 762.131 465.459",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 762.709,
    cy: 436.207,
    rx: 20.1875,
    ry: 20.2803,
    transform: "rotate(35.1824 762.709 436.207)",
    fill: "#D5D8DD"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 773.818,
    cy: 425.946,
    rx: 3.5625,
    ry: 2.11253,
    transform: "rotate(35.1824 773.818 425.946)",
    fill: "#9DA4AF"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M758.668 424.27C758.716 424.507 758.79 424.585 758.917 424.765",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M750.24 434.949C750.299 435.243 750.441 435.52 750.539 435.799",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M759.533 447.251C759.775 447.385 760.015 447.403 760.284 447.46",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M777.82 437.451C777.142 437.828 776.452 438.161 775.816 438.595",
    stroke: "#B9BEC6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M726.661 579.976C724.883 580.167 723.677 578.251 724.658 576.755C728.168 571.401 734.924 561.698 740.247 557.679C745.658 553.594 753.188 545.686 757.006 541.549C758.111 540.352 760.094 540.743 760.608 542.289C762.169 546.985 764.789 555.471 765.256 560.837C765.666 565.551 770.323 571.564 773.9 575.543C775.245 577.039 774.111 579.59 772.102 579.475C765.354 579.089 754.842 578.467 751.473 578.156C747.74 577.812 733.844 579.204 726.661 579.976Z",
    fill: "#B9BEC6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.712,
    cy: 550.767,
    r: 4.23642,
    transform: "rotate(29.1331 745.712 550.767)",
    fill: "#B9BEC6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 746.093,
    cy: 574.016,
    r: 7.41374,
    transform: "rotate(29.1331 746.093 574.016)",
    fill: "#B9BEC6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.848,
    cy: 575.062,
    r: 6.35463,
    transform: "rotate(29.1331 758.848 575.062)",
    fill: "#67717E"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 757.861,
    cy: 544.2,
    r: 7.41374,
    transform: "rotate(29.1331 757.861 544.2)",
    fill: "#B9BEC6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 767.916,
    cy: 563.141,
    r: 6.35463,
    transform: "rotate(29.1331 767.916 563.141)",
    fill: "#67717E"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.908,
    cy: 565.56,
    r: 4.79996,
    transform: "rotate(-120.867 755.908 565.56)",
    fill: "#B9BEC6"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 771.086,
    cy: 574.29,
    r: 5.99995,
    transform: "rotate(-120.867 771.086 574.29)",
    fill: "#B9BEC6"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.521,
    cy: 555.926,
    r: 7.19993,
    transform: "rotate(-120.867 756.521 555.926)",
    fill: "#67717E"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.965,
    cy: 561.052,
    r: 7.19993,
    transform: "rotate(-120.867 743.965 561.052)",
    fill: "#67717E"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.193,
    cy: 577.282,
    r: 5.99995,
    transform: "rotate(-120.867 728.193 577.282)",
    fill: "#B9BEC6"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 733.445,
    cy: 567.86,
    r: 5.99995,
    transform: "rotate(-120.867 733.445 567.86)",
    fill: "#B9BEC6"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.933,
    cy: 574.655,
    r: 5.99995,
    transform: "rotate(-120.867 736.933 574.655)",
    fill: "#67717E"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M762.684 552.951C760.221 548.668 761.87 546.434 763.002 545.853C765.474 543.593 756.738 537.512 757.77 535.662C758.801 533.811 763.426 536.389 772.571 543.911C781.717 551.433 777.485 561.2 781.702 562.338C785.918 563.475 787.965 570.679 789.3 572.635C790.634 574.591 787.541 580.142 785.493 572.938C783.446 565.735 779.639 566.038 778.911 571.695C778.484 575.017 773.649 583.312 773.861 578.58C774.073 573.849 772.026 566.645 767.916 563.142C763.806 559.638 758.559 560.351 759.696 556.135C760.833 551.919 765.762 558.304 762.684 552.951Z",
    fill: "#F1F2F4"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M718.569 573.594C717.432 574.975 715.23 574.449 714.883 572.694C713.604 566.244 711.54 554.085 712.569 547.227C713.615 540.258 713.445 528.879 713.27 523.106C713.221 521.478 714.909 520.371 716.358 521.115C720.882 523.436 729.038 527.841 733.292 531.488C737.043 534.705 744.959 535.761 750.482 536.099C752.49 536.222 753.468 538.833 751.953 540.157C746.705 544.741 738.375 551.991 735.641 554.217C732.621 556.675 723.28 567.868 718.569 573.594Z",
    fill: "#B9BEC6"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 711.606,
    cy: 538.181,
    r: 4.37338,
    transform: "rotate(-15.2811 711.606 538.181)",
    fill: "#B9BEC6"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.683,
    cy: 555.051,
    r: 7.65341,
    transform: "rotate(-15.2811 728.683 555.051)",
    fill: "#B9BEC6"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.844,
    cy: 546.607,
    r: 6.56007,
    transform: "rotate(-15.2811 738.844 546.607)",
    fill: "#67717E"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.82,
    cy: 524.563,
    r: 7.65341,
    transform: "rotate(-15.2811 715.82 524.563)",
    fill: "#B9BEC6"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.918,
    cy: 531.266,
    r: 6.56007,
    transform: "rotate(-15.2811 736.918 531.266)",
    fill: "#67717E"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.812,
    cy: 541.723,
    r: 4.95513,
    transform: "rotate(-165.281 729.812 541.723)",
    fill: "#B9BEC6"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 747.312,
    cy: 537.197,
    r: 6.19392,
    transform: "rotate(-165.281 747.312 537.197)",
    fill: "#B9BEC6"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.303,
    cy: 534.176,
    r: 7.4327,
    transform: "rotate(-165.281 723.303 534.176)",
    fill: "#67717E"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.749,
    cy: 547.028,
    r: 7.4327,
    transform: "rotate(-165.281 717.749 547.028)",
    fill: "#67717E"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.845,
    cy: 570.391,
    r: 6.19392,
    transform: "rotate(-165.281 717.845 570.391)",
    fill: "#B9BEC6"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.909,
    cy: 559.65,
    r: 6.19392,
    transform: "rotate(-165.281 714.909 559.65)",
    fill: "#B9BEC6"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.39,
    cy: 562.14,
    r: 6.19392,
    transform: "rotate(-165.281 722.39 562.14)",
    fill: "#67717E"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M725.699 527.531C720.789 526.152 720.391 523.314 720.806 522.067C720.996 518.615 710.161 520.442 709.585 518.333C709.008 516.223 714.282 514.783 726.46 513.722C738.637 512.662 742.574 522.921 746.504 520.713C750.435 518.506 757.149 522.339 759.547 522.817C761.944 523.295 763.673 529.624 756.959 525.791C750.245 521.958 747.657 524.932 751.207 529.629C753.292 532.387 755.72 541.997 752.458 538.355C749.196 534.712 742.481 530.88 736.92 531.266C731.358 531.652 728.004 535.969 725.797 532.038C723.589 528.108 731.837 529.254 725.699 527.531Z",
    fill: "#F1F2F4"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M589.041 560.908C584.925 565.996 572.081 573.438 566.993 569.322C561.905 565.205 566.499 551.09 570.615 546.002C574.732 540.914 582.193 540.127 587.281 544.243C592.369 548.359 593.157 555.82 589.041 560.908Z",
    fill: "#B9BEC6"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M578.912 543.49L575.874 542.894C575.136 542.749 574.949 541.85 575.641 541.556C579.105 540.086 583.401 541.278 585.54 542.277C585.699 542.351 585.875 542.381 586.049 542.358L589.024 541.959C589.199 541.936 589.375 541.985 589.513 542.096C589.886 542.398 589.807 542.989 589.367 543.182L588.948 543.367C588.358 543.626 588.235 544.421 588.656 544.91C590.698 547.284 591.612 550.603 591.949 553.377C592.061 554.301 591.005 554.508 590.656 553.646L590.588 553.476C590.36 552.915 589.613 552.804 589.232 553.275C588.87 553.723 588.166 553.649 587.905 553.135L585.826 549.041C585.688 548.769 585.418 548.588 585.113 548.563L581.621 548.283C581.276 548.255 580.98 548.028 580.864 547.702L579.57 544.058C579.467 543.766 579.216 543.55 578.912 543.49Z",
    fill: "#818A98"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M575.089 548.875C575.223 548.983 575.303 549.033 575.457 549.067",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M581.529 553.457C581.547 553.751 581.535 553.985 581.779 554.182",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M587.182 558.239C586.96 558.252 586.61 558.212 586.522 558.02",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M580.189 561.58C580 561.476 579.733 561.525 579.593 561.411",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M574.156 557.011L574.511 557.09",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M569.727 562.22C569.45 562.179 569.177 562.128 568.902 562.076",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M569.194 553.834C569.124 553.789 569.03 553.773 568.953 553.744",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M568.057 566.62L568.436 566.927",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M572.977 565.413L573.356 565.72",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M562.041 560.908C557.925 565.996 545.081 573.438 539.993 569.322C534.905 565.205 539.499 551.09 543.615 546.002C547.732 540.914 555.193 540.127 560.281 544.243C565.369 548.359 566.157 555.82 562.041 560.908Z",
    fill: "#B9BEC6"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M551.912 543.49L548.874 542.894C548.136 542.749 547.949 541.85 548.641 541.556C552.105 540.086 556.401 541.278 558.54 542.277C558.699 542.351 558.875 542.381 559.049 542.358L562.024 541.959C562.199 541.936 562.375 541.985 562.513 542.096C562.886 542.398 562.807 542.989 562.367 543.182L561.948 543.367C561.358 543.626 561.235 544.421 561.656 544.91C563.698 547.284 564.612 550.603 564.949 553.377C565.061 554.301 564.005 554.508 563.656 553.646L563.588 553.476C563.36 552.915 562.613 552.804 562.232 553.275C561.87 553.723 561.166 553.649 560.905 553.135L558.826 549.041C558.688 548.769 558.418 548.588 558.113 548.563L554.621 548.283C554.276 548.255 553.98 548.028 553.864 547.702L552.57 544.058C552.467 543.766 552.216 543.55 551.912 543.49Z",
    fill: "#818A98"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M548.089 548.875C548.223 548.983 548.303 549.033 548.457 549.067",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M554.529 553.457C554.547 553.751 554.535 553.985 554.779 554.182",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M560.182 558.239C559.96 558.252 559.61 558.212 559.522 558.02",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M553.189 561.58C553 561.476 552.733 561.525 552.593 561.411",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M547.156 557.011L547.511 557.09",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M542.727 562.22C542.45 562.179 542.177 562.128 541.902 562.076",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M542.194 553.834C542.124 553.789 542.03 553.773 541.953 553.744",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M541.057 566.62L541.436 566.927",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M545.977 565.413L546.356 565.72",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M585.041 531.507C580.925 536.595 568.081 544.036 562.993 539.92C557.905 535.804 562.499 521.689 566.615 516.601C570.732 511.513 578.193 510.725 583.281 514.841C588.369 518.957 589.157 526.419 585.041 531.507Z",
    fill: "#B9BEC6"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M574.912 514.089L571.874 513.493C571.136 513.348 570.949 512.448 571.641 512.155C575.105 510.684 579.401 511.877 581.54 512.875C581.699 512.95 581.875 512.98 582.049 512.956L585.024 512.558C585.199 512.534 585.375 512.584 585.513 512.695C585.886 512.997 585.807 513.588 585.367 513.781L584.948 513.965C584.358 514.225 584.235 515.02 584.656 515.509C586.698 517.882 587.612 521.201 587.949 523.976C588.061 524.899 587.005 525.106 586.656 524.244L586.588 524.075C586.36 523.513 585.613 523.402 585.232 523.873C584.87 524.322 584.166 524.247 583.905 523.733L581.826 519.639C581.688 519.367 581.418 519.186 581.113 519.162L577.621 518.882C577.276 518.854 576.98 518.626 576.864 518.3L575.57 514.657C575.467 514.364 575.216 514.149 574.912 514.089Z",
    fill: "#818A98"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M571.089 519.473C571.223 519.581 571.303 519.632 571.457 519.666",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M577.529 524.056C577.547 524.349 577.535 524.583 577.779 524.781",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M583.182 528.838C582.96 528.85 582.61 528.811 582.522 528.618",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M576.189 532.178C576 532.075 575.733 532.124 575.593 532.01",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M570.156 527.61L570.511 527.688",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M565.727 532.819C565.45 532.778 565.177 532.726 564.902 532.674",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M565.194 524.433C565.124 524.388 565.03 524.371 564.953 524.343",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M564.057 537.219L564.436 537.525",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M568.977 536.012L569.356 536.319",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M535.261 560.908C531.145 565.996 518.301 573.438 513.213 569.322C508.125 565.205 512.72 551.09 516.836 546.002C520.952 540.914 528.414 540.127 533.502 544.243C538.59 548.359 539.378 555.82 535.261 560.908Z",
    fill: "#B9BEC6"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M525.133 543.49L522.094 542.894C521.357 542.749 521.17 541.85 521.861 541.556C525.326 540.086 529.621 541.278 531.761 542.277C531.92 542.351 532.096 542.381 532.27 542.358L535.245 541.959C535.419 541.936 535.596 541.985 535.733 542.096C536.107 542.398 536.028 542.989 535.588 543.182L535.169 543.367C534.579 543.626 534.456 544.421 534.877 544.91C536.919 547.284 537.833 550.603 538.17 553.377C538.282 554.301 537.226 554.508 536.877 553.646L536.809 553.476C536.581 552.915 535.834 552.804 535.453 553.275C535.09 553.723 534.386 553.649 534.125 553.135L532.047 549.041C531.908 548.769 531.638 548.588 531.334 548.563L527.842 548.283C527.497 548.255 527.201 548.028 527.085 547.702L525.791 544.058C525.687 543.766 525.437 543.55 525.133 543.49Z",
    fill: "#818A98"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M521.31 548.875C521.443 548.983 521.523 549.033 521.678 549.067",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M527.75 553.457C527.768 553.751 527.756 553.985 528 554.182",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M533.402 558.239C533.181 558.252 532.831 558.212 532.743 558.02",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M526.409 561.58C526.22 561.476 525.954 561.525 525.813 561.411",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M520.376 557.011L520.731 557.09",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M515.948 562.22C515.671 562.179 515.398 562.128 515.123 562.076",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M515.414 553.834C515.344 553.789 515.25 553.773 515.173 553.744",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M514.277 566.62L514.657 566.927",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M519.197 565.413L519.577 565.72",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M558.261 531.507C554.145 536.595 541.301 544.036 536.213 539.92C531.125 535.804 535.72 521.689 539.836 516.601C543.952 511.513 551.414 510.725 556.502 514.841C561.59 518.957 562.378 526.419 558.261 531.507Z",
    fill: "#B9BEC6"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M548.133 514.089L545.094 513.493C544.357 513.348 544.17 512.448 544.861 512.155C548.326 510.684 552.621 511.877 554.761 512.875C554.92 512.95 555.096 512.98 555.27 512.956L558.245 512.558C558.419 512.534 558.596 512.584 558.733 512.695C559.107 512.997 559.028 513.588 558.588 513.781L558.169 513.965C557.579 514.225 557.456 515.02 557.877 515.509C559.919 517.882 560.833 521.201 561.17 523.976C561.282 524.899 560.226 525.106 559.877 524.244L559.809 524.075C559.581 523.513 558.834 523.402 558.453 523.873C558.09 524.322 557.386 524.247 557.125 523.733L555.047 519.639C554.908 519.367 554.638 519.186 554.334 519.162L550.842 518.882C550.497 518.854 550.201 518.626 550.085 518.3L548.791 514.657C548.687 514.364 548.437 514.149 548.133 514.089Z",
    fill: "#818A98"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M544.31 519.473C544.443 519.581 544.523 519.632 544.678 519.666",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M550.75 524.056C550.768 524.349 550.756 524.583 551 524.781",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M556.402 528.838C556.181 528.85 555.831 528.811 555.743 528.618",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M549.409 532.178C549.22 532.075 548.954 532.124 548.813 532.01",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M543.376 527.61L543.731 527.688",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M538.948 532.819C538.671 532.778 538.398 532.726 538.123 532.674",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M538.414 524.433C538.344 524.388 538.25 524.371 538.173 524.343",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M537.277 537.219L537.657 537.525",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M542.197 536.012L542.577 536.319",
    stroke: "#F1F2F4",
    strokeWidth: 1.31665,
    strokeLinecap: "round"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M671.952 442.95C671.044 440.39 671.647 437.33 672.959 434.952C675.627 430.116 674.252 424.244 669.888 421.837C665.524 419.429 659.823 421.398 657.156 426.234C655.73 428.818 653.369 431.264 650.538 432.093C645.467 433.578 640.808 437.186 637.903 442.452C632.434 452.366 635.253 464.403 644.2 469.338C653.146 474.273 664.831 470.237 670.3 460.324C673.429 454.651 673.845 448.285 671.952 442.95Z",
    fill: "#9DA4AF"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 668.153,
    cy: 424.878,
    rx: 4,
    ry: 1.5,
    transform: "rotate(28.8829 668.153 424.878)",
    fill: "#D5D8DD"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M667.865 424.775C668.878 423.197 669.916 421.255 671.499 420.275C672.113 419.895 672.805 419.61 673.532 419.523C673.951 419.472 674.747 419.538 675.064 419.32",
    stroke: "#3A3F46",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M655.111 431.959C655.551 430.3 657.266 429.468 659.069 428.873C660.088 428.537 660.229 428.847 659.476 429.61C658.08 431.024 656.838 432.968 655.655 435.114C653.481 439.054 648.726 440.428 645.329 441.41C641.933 442.391 637.676 448.037 642.219 440.836C646.763 433.635 654.054 435.944 655.111 431.959Z",
    fill: "#D5D8DD"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M684.829 469.95C683.921 467.39 684.524 464.33 685.836 461.952C688.504 457.116 687.129 451.244 682.765 448.837C678.4 446.429 672.7 448.398 670.033 453.234C668.607 455.818 666.246 458.264 663.415 459.093C658.344 460.578 653.685 464.186 650.78 469.452C645.311 479.366 648.13 491.403 657.077 496.338C666.023 501.273 677.708 497.237 683.177 487.324C686.306 481.651 686.722 475.285 684.829 469.95Z",
    fill: "#B9BEC6"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 681.03,
    cy: 451.878,
    rx: 4,
    ry: 1.5,
    transform: "rotate(28.8829 681.03 451.878)",
    fill: "#67717E"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M680.742 451.775C681.755 450.197 682.792 448.255 684.376 447.275C684.99 446.895 685.682 446.61 686.409 446.523C686.828 446.472 687.624 446.538 687.941 446.32",
    stroke: "#22343C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M667.988 458.959C668.428 457.3 670.143 456.468 671.946 455.873C672.965 455.537 673.106 455.847 672.352 456.61C670.957 458.024 669.715 459.968 668.531 462.114C666.358 466.054 661.603 467.428 658.206 468.41C654.81 469.391 650.553 475.037 655.096 467.836C659.64 460.635 666.931 462.944 667.988 458.959Z",
    fill: "#F1F2F4"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M650.952 470.95C650.044 468.39 650.647 465.33 651.959 462.952C654.627 458.116 653.252 452.244 648.888 449.837C644.524 447.429 638.823 449.398 636.156 454.234C634.73 456.818 632.369 459.264 629.538 460.093C624.467 461.578 619.808 465.186 616.903 470.452C611.434 480.366 614.253 492.403 623.2 497.338C632.146 502.273 643.831 498.237 649.3 488.324C652.429 482.651 652.845 476.285 650.952 470.95Z",
    fill: "white"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.153,
    cy: 452.878,
    rx: 4,
    ry: 1.5,
    transform: "rotate(28.8829 647.153 452.878)",
    fill: "#9DA4AF"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M646.865 452.775C647.878 451.197 648.916 449.255 650.499 448.275C651.113 447.895 651.805 447.61 652.532 447.523C652.951 447.472 653.747 447.538 654.064 447.32",
    stroke: "#505862",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M634.111 459.959C634.551 458.3 636.266 457.468 638.069 456.873C639.088 456.537 639.229 456.847 638.476 457.61C637.08 459.024 635.838 460.968 634.655 463.114C632.481 467.054 627.726 468.428 624.329 469.41C620.933 470.391 616.676 476.037 621.219 468.836C625.763 461.635 633.054 463.944 634.111 459.959Z",
    fill: "#D5D8DD"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 1091.12,
    y: 246.364,
    width: 35.8355,
    height: 79.1367,
    transform: "rotate(90 1091.12 246.364)",
    fill: "#818A98"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 1095.1,
    y: 246.364,
    width: 35.8355,
    height: 3.98172,
    transform: "rotate(90 1095.1 246.364)",
    fill: "#505862"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 1011.98,
    y: 246.364,
    width: 35.8355,
    height: 3.98172,
    transform: "rotate(90 1011.98 246.364)",
    fill: "#505862"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1049.31,
    cy: 263.287,
    rx: 13.4383,
    ry: 25.8812,
    transform: "rotate(90 1049.31 263.287)",
    fill: "#67717E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4896_19525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1023,
    y: 249,
    width: 53,
    height: 28
  }, _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1049.31,
    cy: 263.287,
    rx: 13.4383,
    ry: 25.8812,
    transform: "rotate(90 1049.31 263.287)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4896_19525)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1075.19 249.351L1075.19 248.356L1023.43 248.356L1023.43 249.351L1075.19 249.351ZM1075.19 265.278L1075.19 264.283L1023.43 264.283L1023.43 265.278L1075.19 265.278ZM1075.19 256.319L1075.19 257.314L1023.43 257.314L1023.43 256.319L1075.19 256.319ZM1075.19 273.241L1075.19 272.246L1023.43 272.246L1023.43 273.241L1075.19 273.241ZM1075.19 252.337L1075.19 253.333L1023.43 253.333L1023.43 252.337L1075.19 252.337ZM1075.19 269.26L1075.19 268.264L1023.43 268.264L1023.43 269.26L1075.19 269.26ZM1075.19 260.301L1075.19 261.297L1023.43 261.297L1023.43 260.301L1075.19 260.301ZM1075.19 277.223L1075.19 276.227L1023.43 276.227L1023.43 277.223L1075.19 277.223ZM1075.19 250.347L1075.19 251.342L1023.43 251.342L1023.43 250.347L1075.19 250.347ZM1075.19 267.269L1075.19 266.273L1023.43 266.273L1023.43 267.269L1075.19 267.269ZM1075.19 258.31L1075.19 259.305L1023.43 259.305L1023.43 258.31L1075.19 258.31ZM1075.19 275.232L1075.19 274.237L1023.43 274.237L1023.43 275.232L1075.19 275.232ZM1075.19 254.328L1075.19 255.324L1023.43 255.324L1023.43 254.328L1075.19 254.328ZM1075.19 271.251L1075.19 270.255L1023.43 270.255L1023.43 271.251L1075.19 271.251ZM1075.19 262.292L1075.19 263.287L1023.43 263.287L1023.43 262.292L1075.19 262.292ZM1075.19 279.214L1075.19 278.219L1023.43 278.219L1023.43 279.214L1075.19 279.214Z",
    fill: "#B9BEC6"
  }))), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.31 249.848C1042.45 249.848 1035.86 251.264 1031.01 253.784C1026.16 256.304 1023.43 259.722 1023.43 263.286C1023.43 266.85 1026.16 270.268 1031.01 272.789C1035.86 275.309 1042.45 276.725 1049.31 276.725L1049.31 263.286L1049.31 249.848Z",
    fill: "#B9BEC6"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 1091.12,
    y: 208,
    width: 35.8355,
    height: 79.1367,
    transform: "rotate(90 1091.12 208)",
    fill: "#818A98"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 1095.1,
    y: 208,
    width: 35.8355,
    height: 3.98172,
    transform: "rotate(90 1095.1 208)",
    fill: "#505862"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 1011.98,
    y: 208,
    width: 35.8355,
    height: 3.98172,
    transform: "rotate(90 1011.98 208)",
    fill: "#505862"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1049.31,
    cy: 224.922,
    rx: 13.4383,
    ry: 25.8812,
    transform: "rotate(90 1049.31 224.922)",
    fill: "#67717E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4896_19525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1023,
    y: 211,
    width: 53,
    height: 28
  }, _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1049.31,
    cy: 224.922,
    rx: 13.4383,
    ry: 25.8812,
    transform: "rotate(90 1049.31 224.922)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4896_19525)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1075.19 210.987L1075.19 209.991L1023.43 209.991L1023.43 210.987L1075.19 210.987ZM1075.19 226.914L1075.19 225.918L1023.43 225.918L1023.43 226.914L1075.19 226.914ZM1075.19 217.955L1075.19 218.95L1023.43 218.95L1023.43 217.955L1075.19 217.955ZM1075.19 234.877L1075.19 233.882L1023.43 233.882L1023.43 234.877L1075.19 234.877ZM1075.19 213.973L1075.19 214.968L1023.43 214.968L1023.43 213.973L1075.19 213.973ZM1075.19 230.895L1075.19 229.9L1023.43 229.9L1023.43 230.895L1075.19 230.895ZM1075.19 221.937L1075.19 222.932L1023.43 222.932L1023.43 221.937L1075.19 221.937ZM1075.19 238.859L1075.19 237.863L1023.43 237.863L1023.43 238.859L1075.19 238.859ZM1075.19 211.983L1075.19 212.978L1023.43 212.978L1023.43 211.983L1075.19 211.983ZM1075.19 228.904L1075.19 227.909L1023.43 227.909L1023.43 228.904L1075.19 228.904ZM1075.19 219.946L1075.19 220.941L1023.43 220.941L1023.43 219.946L1075.19 219.946ZM1075.19 236.868L1075.19 235.873L1023.43 235.873L1023.43 236.868L1075.19 236.868ZM1075.19 215.964L1075.19 216.96L1023.43 216.96L1023.43 215.964L1075.19 215.964ZM1075.19 232.887L1075.19 231.891L1023.43 231.891L1023.43 232.887L1075.19 232.887ZM1075.19 223.927L1075.19 224.923L1023.43 224.923L1023.43 223.927L1075.19 223.927ZM1075.19 240.85L1075.19 239.854L1023.43 239.854L1023.43 240.85L1075.19 240.85Z",
    fill: "#B9BEC6"
  }))), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.31 211.484C1042.45 211.484 1035.86 212.9 1031.01 215.42C1026.16 217.94 1023.43 221.358 1023.43 224.922C1023.43 228.486 1026.16 231.904 1031.01 234.424C1035.86 236.945 1042.45 238.36 1049.31 238.36L1049.31 224.922L1049.31 211.484Z",
    fill: "#B9BEC6"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M988.263 51.593H965.054V57.5792C960.62 60.746 957.773 65.6526 957.773 71.1607C957.773 76.0834 960.047 80.5256 963.696 83.6748C963.395 84.1102 963.234 84.568 963.234 85.0404C963.234 87.9306 969.244 90.2736 976.658 90.2736C984.072 90.2736 990.083 87.9306 990.083 85.0404C990.083 84.6583 989.978 84.2857 989.778 83.9268C993.601 80.7649 995.999 76.2162 995.999 71.1607C995.999 65.4664 992.957 60.4149 988.263 57.2641V51.593Z",
    fill: "#F1F2F4"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M964.145 53.3848C964.145 51.1384 965.966 49.3174 968.212 49.3174H984.95C987.282 49.3174 989.173 51.2079 989.173 53.5399C989.173 54.8898 988.505 56.1412 987.232 56.5921C985.403 57.2404 982.158 58 976.999 58C971.768 58 968.276 57.2192 966.268 56.5651C964.909 56.1225 964.145 54.8138 964.145 53.3848Z",
    fill: "#818A98"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 976.5,
    cy: 51,
    rx: 11.5,
    ry: 3,
    fill: "#505862"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 966.34,
    y: 64.7893,
    width: 21.843,
    height: 13.6519,
    rx: 5,
    fill: "#9DA4AF"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M961.79 71.3875C960.657 67.2792 962.298 63.5477 963.904 61.3083C964.654 60.2619 966.081 60.1122 965.95 61.3932C965.824 62.6325 965.12 64.388 963.838 65.9268C961.562 68.6572 963.61 77.9859 961.79 71.3875Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M946.489 51.593H923.281V57.5792C918.846 60.746 916 65.6526 916 71.1607C916 76.0834 918.273 80.5256 921.922 83.6748C921.621 84.1102 921.461 84.568 921.461 85.0404C921.461 87.9306 927.471 90.2736 934.885 90.2736C942.299 90.2736 948.309 87.9306 948.309 85.0404C948.309 84.6583 948.204 84.2857 948.005 83.9268C951.827 80.7649 954.225 76.2162 954.225 71.1607C954.225 65.4664 951.183 60.4149 946.489 57.2641V51.593Z",
    fill: "#F1F2F4"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M922.371 53.3848C922.371 51.1384 924.192 49.3174 926.439 49.3174H943.177C945.509 49.3174 947.4 51.2079 947.4 53.5399C947.4 54.8898 946.731 56.1412 945.459 56.5921C943.629 57.2404 940.385 58 935.226 58C929.995 58 926.502 57.2192 924.494 56.5651C923.136 56.1225 922.371 54.8138 922.371 53.3848Z",
    fill: "#818A98"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 934.727,
    cy: 51,
    rx: 11.5,
    ry: 3,
    fill: "#505862"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 924.566,
    y: 64.7893,
    width: 21.843,
    height: 13.6519,
    rx: 5,
    fill: "#9DA4AF"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M920.016 71.3875C918.883 67.2792 920.525 63.5477 922.13 61.3083C922.881 60.2619 924.307 60.1122 924.177 61.3932C924.051 62.6325 923.346 64.388 922.064 65.9268C919.789 68.6572 921.837 77.9859 920.016 71.3875Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.489 10.593H944.281V16.5792C939.846 19.746 937 24.6526 937 30.1607C937 35.0834 939.273 39.5256 942.922 42.6748C942.621 43.1102 942.461 43.568 942.461 44.0404C942.461 46.9306 948.471 49.2736 955.885 49.2736C963.299 49.2736 969.309 46.9306 969.309 44.0404C969.309 43.6583 969.204 43.2857 969.005 42.9268C972.827 39.7649 975.225 35.2162 975.225 30.1607C975.225 24.4664 972.183 19.4149 967.489 16.2641V10.593Z",
    fill: "#F1F2F4"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M943.371 12.3848C943.371 10.1384 945.192 8.31738 947.439 8.31738H964.177C966.509 8.31738 968.4 10.2079 968.4 12.5399C968.4 13.8898 967.731 15.1412 966.459 15.5921C964.629 16.2404 961.385 17 956.226 17C950.995 17 947.502 16.2192 945.494 15.5651C944.136 15.1225 943.371 13.8138 943.371 12.3848Z",
    fill: "#818A98"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 955.727,
    cy: 10,
    rx: 11.5,
    ry: 3,
    fill: "#505862"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 945.566,
    y: 23.7893,
    width: 21.843,
    height: 13.6519,
    rx: 5,
    fill: "#9DA4AF"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M941.016 30.3875C939.883 26.2792 941.525 22.5477 943.13 20.3083C943.881 19.2619 945.307 19.1122 945.177 20.3932C945.051 21.6325 944.346 23.388 943.064 24.9268C940.789 27.6572 942.837 36.9859 941.016 30.3875Z",
    fill: "white"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    y: 700,
    width: 299,
    height: 100,
    fill: "#9DA4AF"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.5,
    cy: 717.5,
    r: 2.5,
    fill: "#67717E"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 717.5,
    r: 2.5,
    fill: "#67717E"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.5,
    cy: 749.5,
    r: 2.5,
    fill: "#67717E"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 749.5,
    r: 2.5,
    fill: "#67717E"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.5,
    cy: 781.5,
    r: 2.5,
    fill: "#67717E"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 781.5,
    r: 2.5,
    fill: "#67717E"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M23 728.534C28.1586 724.041 35.6359 726.266 41.725 727.159C45.6994 727.742 49.4569 728.857 53.5342 728.857C56.0251 728.857 58.3873 727.932 60.7734 727.361C62.8185 726.872 64.1474 725.622 66.395 725.622C69.706 725.622 72.3958 726.412 75.6159 726.997C78.9727 727.607 81.8589 727.924 85.2413 727.078",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4129 732.902C72.4664 732.018 70.0344 731.888 67.2434 733.084C64.3471 734.325 61.9511 734.722 58.7505 734.722C55.484 734.722 52.3446 733.266 49.0645 733.266C46.8549 733.266 44.8771 734.186 42.6543 733.63",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M183.88 777.672C177.854 780.685 172.108 778.927 165.883 777.854C162.813 777.324 160.067 778.096 157.127 778.926C155.066 779.507 152.335 780.706 150.232 780.928C147.785 781.185 145.618 782.375 143.114 782.404C139.118 782.45 135.376 781.618 131.466 780.948C128.061 780.364 124.772 779.987 121.396 781.029C119.74 781.54 118.266 782.04 116.543 782.04",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M140.566 787.136C136.445 787.352 132.968 788.896 128.898 787.297C125.514 785.968 122.522 785.68 118.949 785.68C116.087 785.68 113.98 787.193 111.326 787.783C109.096 788.278 106.663 787.668 104.531 787.136",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M284.705 711.791C278.436 713.517 272.294 715.026 265.757 715.026C258.472 715.026 251.376 713.66 244.08 714.339C239.295 714.784 234.603 715.7 229.783 715.795C226.663 715.856 223.792 716.017 220.684 715.411C218.88 715.059 217.037 714.339 215.184 714.339",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M221.371 709.971C224.506 710.34 227.346 711.066 230.471 710.719C232.978 710.441 235.297 709.882 237.791 709.445C242.737 708.58 247.413 709.243 252.31 709.243",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 599,
    width: 398,
    height: 100,
    fill: "#9DA4AF"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.5,
    cy: 616.5,
    r: 2.5,
    fill: "#67717E"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.5,
    cy: 648.5,
    r: 2.5,
    fill: "#67717E"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.5,
    cy: 680.5,
    r: 2.5,
    fill: "#67717E"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.5,
    cy: 616.5,
    r: 2.5,
    fill: "#67717E"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.5,
    cy: 648.5,
    r: 2.5,
    fill: "#67717E"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.5,
    cy: 680.5,
    r: 2.5,
    fill: "#67717E"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M428.359 630.279C433.518 625.786 440.995 628.011 447.084 628.904C451.059 629.487 454.816 630.603 458.894 630.603C461.384 630.603 463.747 629.677 466.133 629.106C468.178 628.617 469.507 627.367 471.754 627.367C475.065 627.367 477.755 628.157 480.975 628.742C484.332 629.353 487.218 629.669 490.601 628.823",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M480.772 634.647C477.826 633.763 475.394 633.633 472.603 634.829C469.706 636.07 467.31 636.467 464.11 636.467C460.843 636.467 457.704 635.011 454.424 635.011C452.214 635.011 450.236 635.931 448.014 635.375",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M589.239 679.417C583.214 682.43 577.467 680.672 571.242 679.599C568.172 679.07 565.426 679.842 562.487 680.671C560.425 681.252 557.694 682.451 555.591 682.673C553.144 682.93 550.978 684.12 548.473 684.149C544.477 684.195 540.735 683.363 536.826 682.693C533.42 682.109 530.131 681.732 526.755 682.774C525.099 683.285 523.625 683.785 521.902 683.785",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M545.925 688.881C541.805 689.098 538.328 690.642 534.257 689.043C530.873 687.713 527.881 687.425 524.308 687.425C521.446 687.425 519.34 688.938 516.685 689.528C514.456 690.023 512.022 689.414 509.891 688.881",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M690.064 613.536C683.795 615.262 677.653 616.772 671.117 616.772C663.831 616.772 656.735 615.405 649.439 616.084C644.654 616.529 639.963 617.445 635.143 617.54C632.022 617.601 629.152 617.762 626.043 617.156C624.239 616.804 622.397 616.084 620.543 616.084",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M626.73 611.716C629.865 612.085 632.706 612.811 635.83 612.464C638.337 612.186 640.657 611.627 643.15 611.19C648.097 610.325 652.772 610.988 657.669 610.988",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M775.236 674.322C767.836 674.411 760.39 674.339 753.215 676.323C747.465 677.914 741.301 679.056 735.319 678.325C729.673 677.636 724.266 675.511 718.575 675.09C716.368 674.926 714.117 675.05 711.902 675.05",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M753.031 669.59C756.988 667.384 760.6 666.197 765.164 666.759C768.625 667.185 771.941 667.549 775.315 668.498C779.782 669.754 783.977 670.542 788.459 668.862C790.648 668.041 792.198 667.77 794.525 667.77",
    stroke: "#818A98",
    strokeLinecap: "round"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M1200 84H905C902.239 84 900 86.2386 900 89V96C900 98.7614 902.239 101 905 101H1200V84Z",
    fill: "#67717E"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M972.156 215.348C974.976 215.348 977.262 217.634 977.262 220.454V228.743C977.262 233.2 980.413 237.22 983.216 240.686C987.531 246.021 990.312 254.727 990.312 260.5C990.312 265.523 988.207 273.172 984.818 277.103C984.061 277.981 983.504 279.054 983.504 280.214C983.504 282.305 981.808 284 979.717 284H964.595C962.504 284 960.809 282.305 960.809 280.214C960.809 279.054 960.251 277.981 959.494 277.103C956.105 273.172 954 265.523 954 260.5C954 254.996 956.528 246.827 960.502 241.454C960.4 241.415 960.298 241.375 960.197 241.332C958.575 240.648 957.206 239.478 956.278 237.983C955.35 236.487 954.909 234.741 955.016 232.985C955.122 231.228 955.772 229.548 956.874 228.176C957.976 226.804 959.477 225.808 961.169 225.326C962.862 224.843 964.662 224.898 966.322 225.482C966.57 225.569 966.813 225.668 967.05 225.777V220.454C967.05 217.634 969.336 215.348 972.156 215.348ZM966.879 230.56C966.372 229.977 965.721 229.533 964.987 229.275C964.112 228.967 963.164 228.938 962.272 229.193C961.38 229.447 960.589 229.972 960.008 230.695C959.428 231.417 959.085 232.303 959.029 233.228C958.973 234.154 959.205 235.074 959.694 235.862C960.183 236.65 960.905 237.267 961.759 237.627C962.226 237.824 962.72 237.939 963.22 237.97C964.904 235.687 966.389 233.208 966.879 230.56Z",
    fill: "#B9BEC6"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M976.769 267.621C979.317 270.169 983.662 270.139 984.677 266.681C984.786 266.31 984.878 265.934 984.954 265.553C985.458 263.022 985.199 260.398 984.211 258.013C983.224 255.629 981.551 253.591 979.405 252.157C977.259 250.723 974.736 249.958 972.155 249.958C969.574 249.958 967.051 250.723 964.905 252.157C962.759 253.591 961.087 255.629 960.099 258.013C959.111 260.398 958.853 263.022 959.356 265.553C959.432 265.934 959.525 266.31 959.633 266.681C960.648 270.139 964.993 270.169 967.541 267.621C970.089 265.073 974.221 265.073 976.769 267.621Z",
    fill: "white"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 967.049,
    y: 214.78,
    width: 10.2128,
    height: 4.53901,
    fill: "#9DA4AF"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M967.049 209C967.049 206.239 969.287 204 972.049 204H972.262C975.023 204 977.262 206.239 977.262 209V214.78H967.049V209Z",
    fill: "#505862"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.156 215.348C936.976 215.348 939.262 217.634 939.262 220.454V228.743C939.262 233.2 942.413 237.22 945.216 240.686C949.531 246.021 952.312 254.727 952.312 260.5C952.312 265.523 950.207 273.172 946.818 277.103C946.061 277.981 945.504 279.054 945.504 280.214C945.504 282.305 943.808 284 941.717 284H926.595C924.504 284 922.809 282.305 922.809 280.214C922.809 279.054 922.251 277.981 921.494 277.103C918.105 273.172 916 265.523 916 260.5C916 254.996 918.528 246.827 922.502 241.454C922.4 241.415 922.298 241.375 922.197 241.332C920.575 240.648 919.206 239.478 918.278 237.983C917.35 236.487 916.909 234.741 917.016 232.985C917.122 231.228 917.772 229.548 918.874 228.176C919.976 226.804 921.477 225.808 923.169 225.326C924.862 224.843 926.662 224.898 928.322 225.482C928.57 225.569 928.813 225.668 929.05 225.777V220.454C929.05 217.634 931.336 215.348 934.156 215.348ZM928.879 230.56C928.372 229.977 927.721 229.533 926.987 229.275C926.112 228.967 925.164 228.938 924.272 229.193C923.38 229.447 922.589 229.972 922.008 230.695C921.428 231.417 921.085 232.303 921.029 233.228C920.973 234.154 921.205 235.074 921.694 235.862C922.183 236.65 922.905 237.267 923.759 237.627C924.226 237.824 924.72 237.939 925.22 237.97C926.904 235.687 928.389 233.208 928.879 230.56Z",
    fill: "#818A98"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M938.769 267.621C941.317 270.169 945.662 270.139 946.677 266.681C946.786 266.31 946.878 265.934 946.954 265.553C947.458 263.022 947.199 260.398 946.211 258.013C945.224 255.629 943.551 253.591 941.405 252.157C939.259 250.723 936.736 249.958 934.155 249.958C931.574 249.958 929.051 250.723 926.905 252.157C924.759 253.591 923.087 255.629 922.099 258.013C921.111 260.398 920.853 263.022 921.356 265.553C921.432 265.934 921.525 266.31 921.633 266.681C922.648 270.139 926.993 270.169 929.541 267.621C932.089 265.073 936.221 265.073 938.769 267.621Z",
    fill: "white"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 929.049,
    y: 214.78,
    width: 10.2128,
    height: 4.53901,
    fill: "#67717E"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M929.049 209C929.049 206.239 931.287 204 934.049 204H934.262C937.023 204 939.262 206.239 939.262 209V214.78H929.049V209Z",
    fill: "#505862"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M145.223 681.927C157.315 688.705 166.177 685.625 168.54 678.812C163.638 659.938 127.35 636.977 110.877 639.189C97.6989 640.958 102.176 651.435 106.062 656.453C97.7097 658.106 94.7367 664.56 107.696 662.744C120.656 660.928 130.108 673.455 145.223 681.927Z",
    fill: "#818A98"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M162.331 663.547C172.064 673.444 168.372 681.056 165.31 683.625C142.65 679.54 107.408 648.76 107.43 635.33C107.448 624.585 120.298 628.286 126.72 631.48C127.348 624.672 134.379 622.276 134.273 632.842C134.168 643.407 150.164 651.176 162.331 663.547Z",
    fill: "#D5D8DD"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M164.449 662.012C172.406 671.589 169.072 679.265 166.41 681.906C147.36 678.472 118.41 648.826 118.802 635.463C119.116 624.772 129.881 628.097 135.224 631.096C135.944 624.305 141.957 621.725 141.574 632.241C141.191 642.756 154.504 650.042 164.449 662.012Z",
    fill: "#9DA4AF"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M171.119 671.96C177.964 684.014 187.142 685.96 192.687 681.351C198.251 662.661 179.063 624.244 163.82 617.619C151.625 612.319 150.04 623.603 150.772 629.907C142.768 627.002 136.885 630.99 148.917 636.137C160.949 641.283 162.562 656.892 171.119 671.96Z",
    fill: "#818A98"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M195.264 665.074C198.478 678.578 191.382 683.184 187.432 683.799C170.15 668.585 155.901 624.017 162.864 612.533C168.434 603.346 177.519 613.158 181.366 619.213C185.423 613.71 192.68 615.295 187.126 624.284C181.573 633.273 191.247 648.194 195.264 665.074Z",
    fill: "#D5D8DD"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M197.873 664.856C199.731 677.167 192.908 682.013 189.264 682.898C174.734 670.107 165.284 629.763 172.53 618.528C178.326 609.539 185.821 617.951 188.844 623.281C192.971 617.841 199.452 618.742 193.687 627.545C187.922 636.347 195.549 649.467 197.873 664.856Z",
    fill: "#9DA4AF"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.8 227.668C1120.76 211.019 1140.82 207.858 1150.23 208.358C1166.53 206.095 1182.82 214.795 1188.79 227.668C1193.56 237.967 1193.99 255.56 1193.61 263.07C1194.99 266.288 1200.5 270.566 1193.61 278.075C1186.72 285.585 1168.59 288.387 1141.28 287.958C1113.97 287.529 1105.49 278.732 1104.35 275.728C1103.2 272.724 1105.01 267.575 1108.23 263.07C1111.44 258.564 1109.6 248.48 1115.8 227.668Z",
    fill: "#9DA4AF"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.77 190.187C1123.85 197.962 1130.09 207.441 1133.33 211.208C1136.02 210.645 1138.48 210.202 1140.73 209.859C1163.73 206.342 1165.08 212.136 1164.24 208.017C1163.32 203.496 1172.41 186.796 1168.25 186.796C1164.09 186.796 1170.79 186.796 1159.92 184.083C1149.05 181.371 1140.96 184.31 1133.33 186.796C1125.7 189.282 1125.93 180.467 1124.77 190.187Z",
    fill: "#9DA4AF"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 1150.5,
    cy: 244.5,
    r: 18.5,
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.7 252.08C1144.43 254.247 1140.35 251.247 1139.88 244.303C1144.46 245.324 1151.42 248.251 1146.7 252.08Z",
    fill: "#9DA4AF"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.39 252.367C1148.44 255.505 1153.06 256.329 1157.95 251.81C1154.31 249.251 1147.87 246.318 1148.39 252.367Z",
    fill: "#9DA4AF"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.7 244.806C1148.29 246.732 1143.03 243.978 1143.48 237.135C1146.47 238.431 1152.1 241.543 1149.7 244.806Z",
    fill: "#9DA4AF"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.14 245.485C1151.01 247.871 1156.39 249.035 1160.1 243.431C1157.21 242.564 1151.36 241.443 1151.14 245.485Z",
    fill: "#9DA4AF"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.11 241.647C1156.22 242.887 1157.49 238.756 1154.69 232.437C1152.02 234.645 1146.36 239.072 1152.11 241.647Z",
    fill: "#9DA4AF"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M1200 282H905C902.239 282 900 284.239 900 287V294C900 296.761 902.239 299 905 299H1200V282Z",
    fill: "#67717E"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M1149 206.5C1154.6 205.3 1163 207 1166.5 208C1166.5 209.333 1165.6 211.7 1162 210.5C1157.5 209 1150 209 1145 210.5C1140 212 1133 212 1130.5 210.5C1128 209 1131 208 1135 208C1139 208 1142 208 1149 206.5Z",
    fill: "#67717E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4896_19525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroceryStoreGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GroceryStoreGray.41f22a41f00fd3b1ddedb35c0d9f3e9f.svg";